/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedAuditorRouteRouteImport } from './routes/_protected/auditor/route'
import { Route as ProtectedCorporateFinanceRouteRouteImport } from './routes/_protected/corporate-finance/route'
import { Route as ProtectedDataRouteImport } from './routes/_protected/data'
import { Route as ProtectedFasRouteRouteImport } from './routes/_protected/fas/route'
import { Route as ProtectedSuperuserRouteRouteImport } from './routes/_protected/superuser/route'
import { Route as ProtectedWorkflowsRouteImport } from './routes/_protected/workflows'
import { Route as AuthChangePasswordRouteImport } from './routes/auth/change-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthTwoFaRouteImport } from './routes/auth/two-fa'
import { Route as AuthTwoFaVerifyRouteImport } from './routes/auth/two-fa-verify'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as ProtectedAuditorIndexRouteImport } from './routes/_protected/auditor/index'
import { Route as ProtectedDataCollectionsRouteImport } from './routes/_protected/data/collections'
import { Route as ProtectedDataDatabasesRouteImport } from './routes/_protected/data/databases'
import { Route as ProtectedDataDatasourcesRouteImport } from './routes/_protected/data/datasources'
import { Route as ProtectedDocumentAnalysisIndexRouteImport } from './routes/_protected/document-analysis/index'
import { Route as ProtectedDocumentAnalysisBulkResultsRouteImport } from './routes/_protected/document-analysis/bulk-results'
import { Route as ProtectedDocumentAnalysisComparisonRouteImport } from './routes/_protected/document-analysis/comparison'
import { Route as ProtectedDocumentAnalysisResultsRouteImport } from './routes/_protected/document-analysis/results'
import { Route as ProtectedHelpCenterAdminRouteImport } from './routes/_protected/help-center/admin'
import { Route as ProtectedHistoryIndexRouteImport } from './routes/_protected/history/index'
import { Route as ProtectedNotAuthorizedIndexRouteImport } from './routes/_protected/not-authorized/index'
import { Route as ProtectedOrganizationOrgIdRouteImport } from './routes/_protected/organization/$orgId'
import { Route as ProtectedReportIssueIndexRouteImport } from './routes/_protected/report-issue/index'
import { Route as ProtectedSuperuserIndexRouteImport } from './routes/_protected/superuser/index'
import { Route as ProtectedTemplateEditorIndexRouteImport } from './routes/_protected/template-editor/index'
import { Route as ProtectedTemplateEditorStatementTreesRouteRouteImport } from './routes/_protected/template-editor/statement-trees/route'
import { Route as ProtectedWorkflowEditorIndexRouteImport } from './routes/_protected/workflow-editor/index'
import { Route as ProtectedWorkflowsIndexRouteImport } from './routes/_protected/workflows/index'
import { Route as ProtectedWorkflowsResultsRouteImport } from './routes/_protected/workflows/results'
import { Route as ProtectedWorkflowsScheduleRouteImport } from './routes/_protected/workflows/schedule'
import { Route as AuthWorkosCallbackRouteImport } from './routes/auth/workos/callback'
import { Route as ProtectedAuditorClientsIdRouteImport } from './routes/_protected/auditor/clients/$id'
import { Route as ProtectedCorporateFinanceProjectsIdRouteImport } from './routes/_protected/corporate-finance/projects/$id'
import { Route as ProtectedCorporateFinanceTaxonomiesTaxonomyIdRouteImport } from './routes/_protected/corporate-finance/taxonomies/$taxonomyId'
import { Route as ProtectedCorporateFinanceValidationIndexRouteImport } from './routes/_protected/corporate-finance/validation/index'
import { Route as ProtectedDocumentAnalysisCreateIndexRouteImport } from './routes/_protected/document-analysis/create/index'
import { Route as ProtectedFasProjectsIdRouteImport } from './routes/_protected/fas/projects/$id'
import { Route as ProtectedFasTaxonomiesTaxonomyIdRouteImport } from './routes/_protected/fas/taxonomies/$taxonomyId'
import { Route as ProtectedHelpCenterArticlesIndexRouteImport } from './routes/_protected/help-center/articles/index'
import { Route as ProtectedHelpCenterArticlesNewRouteImport } from './routes/_protected/help-center/articles/new'
import { Route as ProtectedHelpCenterSearchIndexRouteImport } from './routes/_protected/help-center/search/index'
import { Route as ProtectedOrganizationOrgIdIndexRouteImport } from './routes/_protected/organization/$orgId/index'
import { Route as ProtectedOrganizationOrgIdReviewRouteImport } from './routes/_protected/organization/$orgId/review'
import { Route as ProtectedSuperuserUsageIndexRouteImport } from './routes/_protected/superuser/usage/index'
import { Route as ProtectedSuperuserUsageSessionsRouteImport } from './routes/_protected/superuser/usage/sessions'
import { Route as ProtectedSuperuserUserIdRouteImport } from './routes/_protected/superuser/user/$id'
import { Route as ProtectedTemplateEditorStatementTreesTaxonomyIdRouteImport } from './routes/_protected/template-editor/statement-trees/$taxonomyId'
import { Route as ProtectedTemplateEditorStatementTreesNewRouteImport } from './routes/_protected/template-editor/statement-trees/new'
import { Route as ProtectedWorkflowsRunIndexRouteImport } from './routes/_protected/workflows_/run/index'
import { Route as ProtectedAuditorClientsIdAgbwRouteImport } from './routes/_protected/auditor/clients/$id/agbw'
import { Route as ProtectedAuditorClientsIdAgbwResultsRouteImport } from './routes/_protected/auditor/clients/$id/agbw-results'
import { Route as ProtectedCorporateFinanceProjectsIdAccountMappingRouteImport } from './routes/_protected/corporate-finance/projects/$id/account-mapping'
import { Route as ProtectedHelpCenterArticlesIdEditRouteImport } from './routes/_protected/help-center/articles/$id/edit'
import { Route as ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteImport } from './routes/_protected/organization/$orgId_.department.$departmentId'
import { Route as ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRouteImport } from './routes/_protected/template-editor/classification-templates/$templateId/create-version'
import { Route as ProtectedTemplateEditorClassificationTemplatesCreateIndexRouteImport } from './routes/_protected/template-editor/classification-templates/create/index'
import { Route as ProtectedAuditorClientsIdAgbwMetadataRouteImport } from './routes/_protected/auditor/clients/$id/_agbw/metadata'
import { Route as ProtectedAuditorClientsIdClientTabsAgbwOverviewRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/agbw-overview'
import { Route as ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results'
import { Route as ProtectedAuditorClientsIdClientTabsDocumentAnalysisRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/document-analysis'
import { Route as ProtectedAuditorClientsIdClientTabsFinancialExplorerRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/financial-explorer'
import { Route as ProtectedAuditorClientsIdClientTabsInputProcessRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/input-process'
import { Route as ProtectedAuditorClientsIdClientTabsTasksRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/tasks'
import { Route as ProtectedAuditorClientsIdClientTabsValidationsRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/validations'
import { Route as ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRouteImport } from './routes/_protected/auditor/clients/$id/agbw-results/fraud-with-payments'
import { Route as ProtectedAuditorClientsIdAgbwResultsMiscellaneousRouteImport } from './routes/_protected/auditor/clients/$id/agbw-results/miscellaneous'
import { Route as ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRouteImport } from './routes/_protected/auditor/clients/$id/agbw-results/wwft-corruption'
import { Route as ProtectedAuditorClientsIdAnalysisRidRouteImport } from './routes/_protected/auditor/clients/$id/analysis/$rid'
import { Route as ProtectedAuditorClientsIdClassificationsEditorRouteImport } from './routes/_protected/auditor/clients/$id/classifications/editor'
import { Route as ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRouteImport } from './routes/_protected/corporate-finance/projects/$id/_project-tabs/financial-explorer'
import { Route as ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteImport } from './routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process'
import { Route as ProtectedCorporateFinanceProjectsIdAnalysisRidRouteImport } from './routes/_protected/corporate-finance/projects/$id/analysis/$rid'
import { Route as ProtectedFasProjectsIdProjectTabsFinancialExplorerRouteImport } from './routes/_protected/fas/projects/$id/_project-tabs/financial-explorer'
import { Route as ProtectedFasProjectsIdProjectTabsInputProcessRouteImport } from './routes/_protected/fas/projects/$id/_project-tabs/input-process'
import { Route as ProtectedOrganizationOrgIdUserUserIdIndexRouteImport } from './routes/_protected/organization/$orgId/user/$userId/index'
import { Route as ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRouteImport } from './routes/_protected/organization/$orgId_.department.$departmentId.review'
import { Route as ProtectedAuditorClientsIdClientTabsInputProcessClassificationRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/input-process/classification'
import { Route as ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation'
import { Route as ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRouteImport } from './routes/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction'
import { Route as ProtectedAuditorClientsIdClassificationsClsIndexRouteImport } from './routes/_protected/auditor/clients/$id/classifications/$cls/index'
import { Route as ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRouteImport } from './routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process/classification'

const AuthRequestVerifyLazyRouteImport = createFileRoute(
  '/auth/request-verify',
)()
const AuthSignUpLazyRouteImport = createFileRoute('/auth/sign-up')()
const AuthTermsLazyRouteImport = createFileRoute('/auth/terms')()
const ProtectedBiIndexLazyRouteImport = createFileRoute('/_protected/bi/')()
const ProtectedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_protected/help-center/',
)()
const ProtectedNoOrganizationIndexLazyRouteImport = createFileRoute(
  '/_protected/no-organization/',
)()
const ProtectedSettingsIndexLazyRouteImport = createFileRoute(
  '/_protected/settings/',
)()
const ProtectedSuperuserCustomersLazyRouteImport = createFileRoute(
  '/_protected/superuser/customers',
)()
const ProtectedSuperuserSettingsLazyRouteImport = createFileRoute(
  '/_protected/superuser/settings',
)()
const ProtectedSuperuserUsageLazyRouteImport = createFileRoute(
  '/_protected/superuser/usage',
)()
const ProtectedAuditorClientsIndexLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/',
)()
const ProtectedAuditorValidationIndexLazyRouteImport = createFileRoute(
  '/_protected/auditor/validation/',
)()
const ProtectedAuditorValidationCreateLazyRouteImport = createFileRoute(
  '/_protected/auditor/validation/create',
)()
const ProtectedCorporateFinanceProjectsIndexLazyRouteImport = createFileRoute(
  '/_protected/corporate-finance/projects/',
)()
const ProtectedFasProjectsIndexLazyRouteImport = createFileRoute(
  '/_protected/fas/projects/',
)()
const ProtectedHelpCenterAdminArticlesLazyRouteImport = createFileRoute(
  '/_protected/help-center/admin/articles',
)()
const ProtectedHelpCenterAdminFaqsLazyRouteImport = createFileRoute(
  '/_protected/help-center/admin/faqs',
)()
const ProtectedHelpCenterAdminReleaseNotesLazyRouteImport = createFileRoute(
  '/_protected/help-center/admin/release-notes',
)()
const ProtectedHelpCenterAdminTemplatesLazyRouteImport = createFileRoute(
  '/_protected/help-center/admin/templates',
)()
const ProtectedHelpCenterAdminTopicsLazyRouteImport = createFileRoute(
  '/_protected/help-center/admin/topics',
)()
const ProtectedHelpCenterFaqIndexLazyRouteImport = createFileRoute(
  '/_protected/help-center/faq/',
)()
const ProtectedHelpCenterReleaseNotesIndexLazyRouteImport = createFileRoute(
  '/_protected/help-center/release-notes/',
)()
const ProtectedHelpCenterReleaseNotesNewLazyRouteImport = createFileRoute(
  '/_protected/help-center/release-notes/new',
)()
const ProtectedSuperuserUsageConversationsLazyRouteImport = createFileRoute(
  '/_protected/superuser/usage/conversations',
)()
const ProtectedAuditorClientsIdAgbwLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/$id/_agbw',
)()
const ProtectedAuditorClientsIdClientTabsLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/$id/_client-tabs',
)()
const ProtectedAuditorValidationIdIndexLazyRouteImport = createFileRoute(
  '/_protected/auditor/validation/$id/',
)()
const ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteImport =
  createFileRoute('/_protected/corporate-finance/projects/$id/_project-tabs')()
const ProtectedFasProjectsIdProjectTabsLazyRouteImport = createFileRoute(
  '/_protected/fas/projects/$id/_project-tabs',
)()
const ProtectedFasProjectsIdAccountMappingLazyRouteImport = createFileRoute(
  '/_protected/fas/projects/$id/account-mapping',
)()
const ProtectedHelpCenterArticlesIdIndexLazyRouteImport = createFileRoute(
  '/_protected/help-center/articles/$id/',
)()
const ProtectedHelpCenterReleaseNotesIdIndexLazyRouteImport = createFileRoute(
  '/_protected/help-center/release-notes/$id/',
)()
const ProtectedHelpCenterReleaseNotesIdEditLazyRouteImport = createFileRoute(
  '/_protected/help-center/release-notes/$id/edit',
)()
const ProtectedOrganizationOrgIdDepartmentsIndexLazyRouteImport =
  createFileRoute('/_protected/organization/$orgId/departments/')()
const ProtectedOrganizationOrgIdInvitationsIndexLazyRouteImport =
  createFileRoute('/_protected/organization/$orgId/invitations/')()
const ProtectedOrganizationOrgIdTrainingIndexLazyRouteImport = createFileRoute(
  '/_protected/organization/$orgId/training/',
)()
const ProtectedOrganizationOrgIdUsersIndexLazyRouteImport = createFileRoute(
  '/_protected/organization/$orgId/users/',
)()
const ProtectedOrganizationOrgIdReviewSessionIdLazyRouteImport =
  createFileRoute('/_protected/organization/$orgId_/review/$sessionId')()
const ProtectedSuperuserUsageSessionsSessionIdLazyRouteImport = createFileRoute(
  '/_protected/superuser/usage_/sessions/$sessionId',
)()
const ProtectedSuperuserUserIdPermissionsLazyRouteImport = createFileRoute(
  '/_protected/superuser/user/$id/permissions',
)()
const ProtectedSuperuserUserIdRolesLazyRouteImport = createFileRoute(
  '/_protected/superuser/user/$id/roles',
)()
const ProtectedAuditorClientsIdAgbwAffiliatesLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/$id/_agbw/affiliates',
)()
const ProtectedAuditorClientsIdAgbwBatchesLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/$id/_agbw/batches',
)()
const ProtectedAuditorClientsIdAgbwCamtLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/$id/_agbw/camt',
)()
const ProtectedAuditorClientsIdAgbwTrialBalanceLazyRouteImport =
  createFileRoute('/_protected/auditor/clients/$id/_agbw/trial-balance')()
const ProtectedAuditorClientsIdClientTabsIndexLazyRouteImport = createFileRoute(
  '/_protected/auditor/clients/$id/_client-tabs/',
)()
const ProtectedAuditorClientsIdAgbwResultsOverviewLazyRouteImport =
  createFileRoute('/_protected/auditor/clients/$id/agbw-results/overview')()
const ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRouteImport =
  createFileRoute('/_protected/corporate-finance/projects/$id/_project-tabs/')()
const ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/_project-tabs/document-analysis',
  )()
const ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/_project-tabs/workflows',
  )()
const ProtectedFasProjectsIdProjectTabsIndexLazyRouteImport = createFileRoute(
  '/_protected/fas/projects/$id/_project-tabs/',
)()
const ProtectedFasProjectsIdProjectTabsWorkflowsLazyRouteImport =
  createFileRoute('/_protected/fas/projects/$id/_project-tabs/workflows')()
const ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRouteImport =
  createFileRoute(
    '/_protected/organization/$orgId_/department/$departmentId/',
  )()
const ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRouteImport =
  createFileRoute(
    '/_protected/organization/$orgId_/department/$departmentId/members',
  )()
const ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRouteImport =
  createFileRoute(
    '/_protected/auditor/clients/$id/_client-tabs/input-process/',
  )()
const ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRouteImport =
  createFileRoute(
    '/_protected/auditor/clients/$id/_client-tabs/input-process/documents',
  )()
const ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRouteImport =
  createFileRoute(
    '/_protected/auditor/clients/$id/_client-tabs/input-process/trial-balance',
  )()
const ProtectedAuditorClientsIdAnalysisRidResultsLazyRouteImport =
  createFileRoute('/_protected/auditor/clients/$id/analysis/$rid/results')()
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/',
  )()
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/documents',
  )()
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/reconciliation',
  )()
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/statement-extraction',
  )()
const ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRouteImport =
  createFileRoute(
    '/_protected/corporate-finance/projects/$id/analysis/$rid/results',
  )()
const ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRouteImport =
  createFileRoute(
    '/_protected/organization/$orgId_/department/$departmentId_/review/$sessionId',
  )()

const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/index.lazy').then((d) => d.Route),
)
const ProtectedAuditorRouteRoute = ProtectedAuditorRouteRouteImport.update({
  id: '/auditor',
  path: '/auditor',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCorporateFinanceRouteRoute =
  ProtectedCorporateFinanceRouteRouteImport.update({
    id: '/corporate-finance',
    path: '/corporate-finance',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedDataRoute = ProtectedDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/data.lazy').then((d) => d.Route),
)
const ProtectedFasRouteRoute = ProtectedFasRouteRouteImport.update({
  id: '/fas',
  path: '/fas',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSuperuserRouteRoute = ProtectedSuperuserRouteRouteImport.update({
  id: '/superuser',
  path: '/superuser',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWorkflowsRoute = ProtectedWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/workflows.lazy').then((d) => d.Route),
)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRequestVerifyLazyRoute = AuthRequestVerifyLazyRouteImport.update({
  id: '/request-verify',
  path: '/request-verify',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/auth/request-verify.lazy').then((d) => d.Route),
)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpLazyRoute = AuthSignUpLazyRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth/sign-up.lazy').then((d) => d.Route))
const AuthTermsLazyRoute = AuthTermsLazyRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth/terms.lazy').then((d) => d.Route))
const AuthTwoFaRoute = AuthTwoFaRouteImport.update({
  id: '/two-fa',
  path: '/two-fa',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFaVerifyRoute = AuthTwoFaVerifyRouteImport.update({
  id: '/two-fa-verify',
  path: '/two-fa-verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedAuditorIndexRoute = ProtectedAuditorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAuditorRouteRoute,
} as any)
const ProtectedBiIndexLazyRoute = ProtectedBiIndexLazyRouteImport.update({
  id: '/bi/',
  path: '/bi/',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/bi/index.lazy').then((d) => d.Route),
)
const ProtectedDataCollectionsRoute =
  ProtectedDataCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => ProtectedDataRoute,
  } as any).lazy(() =>
    import('./routes/_protected/data/collections.lazy').then((d) => d.Route),
  )
const ProtectedDataDatabasesRoute = ProtectedDataDatabasesRouteImport.update({
  id: '/databases',
  path: '/databases',
  getParentRoute: () => ProtectedDataRoute,
} as any).lazy(() =>
  import('./routes/_protected/data/databases.lazy').then((d) => d.Route),
)
const ProtectedDataDatasourcesRoute =
  ProtectedDataDatasourcesRouteImport.update({
    id: '/datasources',
    path: '/datasources',
    getParentRoute: () => ProtectedDataRoute,
  } as any).lazy(() =>
    import('./routes/_protected/data/datasources.lazy').then((d) => d.Route),
  )
const ProtectedDocumentAnalysisIndexRoute =
  ProtectedDocumentAnalysisIndexRouteImport.update({
    id: '/document-analysis/',
    path: '/document-analysis/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/document-analysis/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDocumentAnalysisBulkResultsRoute =
  ProtectedDocumentAnalysisBulkResultsRouteImport.update({
    id: '/document-analysis/bulk-results',
    path: '/document-analysis/bulk-results',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/document-analysis/bulk-results.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDocumentAnalysisComparisonRoute =
  ProtectedDocumentAnalysisComparisonRouteImport.update({
    id: '/document-analysis/comparison',
    path: '/document-analysis/comparison',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/document-analysis/comparison.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDocumentAnalysisResultsRoute =
  ProtectedDocumentAnalysisResultsRouteImport.update({
    id: '/document-analysis/results',
    path: '/document-analysis/results',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/document-analysis/results.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterIndexLazyRoute =
  ProtectedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/index.lazy').then((d) => d.Route),
  )
const ProtectedHelpCenterAdminRoute =
  ProtectedHelpCenterAdminRouteImport.update({
    id: '/help-center/admin',
    path: '/help-center/admin',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/admin.lazy').then((d) => d.Route),
  )
const ProtectedHistoryIndexRoute = ProtectedHistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/history/index.lazy').then((d) => d.Route),
)
const ProtectedNoOrganizationIndexLazyRoute =
  ProtectedNoOrganizationIndexLazyRouteImport.update({
    id: '/no-organization/',
    path: '/no-organization/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/no-organization/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedNotAuthorizedIndexRoute =
  ProtectedNotAuthorizedIndexRouteImport.update({
    id: '/not-authorized/',
    path: '/not-authorized/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedOrganizationOrgIdRoute =
  ProtectedOrganizationOrgIdRouteImport.update({
    id: '/organization/$orgId',
    path: '/organization/$orgId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedReportIssueIndexRoute =
  ProtectedReportIssueIndexRouteImport.update({
    id: '/report-issue/',
    path: '/report-issue/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/report-issue/index.lazy').then((d) => d.Route),
  )
const ProtectedSettingsIndexLazyRoute =
  ProtectedSettingsIndexLazyRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/settings/index.lazy').then((d) => d.Route),
  )
const ProtectedSuperuserIndexRoute = ProtectedSuperuserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedSuperuserRouteRoute,
} as any)
const ProtectedSuperuserCustomersLazyRoute =
  ProtectedSuperuserCustomersLazyRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => ProtectedSuperuserRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/customers.lazy').then((d) => d.Route),
  )
const ProtectedSuperuserSettingsLazyRoute =
  ProtectedSuperuserSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProtectedSuperuserRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/settings.lazy').then((d) => d.Route),
  )
const ProtectedSuperuserUsageLazyRoute =
  ProtectedSuperuserUsageLazyRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => ProtectedSuperuserRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/usage.lazy').then((d) => d.Route),
  )
const ProtectedTemplateEditorIndexRoute =
  ProtectedTemplateEditorIndexRouteImport.update({
    id: '/template-editor/',
    path: '/template-editor/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/template-editor/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedTemplateEditorStatementTreesRouteRoute =
  ProtectedTemplateEditorStatementTreesRouteRouteImport.update({
    id: '/template-editor/statement-trees',
    path: '/template-editor/statement-trees',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWorkflowEditorIndexRoute =
  ProtectedWorkflowEditorIndexRouteImport.update({
    id: '/workflow-editor/',
    path: '/workflow-editor/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/workflow-editor/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedWorkflowsIndexRoute = ProtectedWorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedWorkflowsRoute,
} as any).lazy(() =>
  import('./routes/_protected/workflows/index.lazy').then((d) => d.Route),
)
const ProtectedWorkflowsResultsRoute =
  ProtectedWorkflowsResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => ProtectedWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/workflows/results.lazy').then((d) => d.Route),
  )
const ProtectedWorkflowsScheduleRoute =
  ProtectedWorkflowsScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => ProtectedWorkflowsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/workflows/schedule.lazy').then((d) => d.Route),
  )
const AuthWorkosCallbackRoute = AuthWorkosCallbackRouteImport.update({
  id: '/workos/callback',
  path: '/workos/callback',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedAuditorClientsIndexLazyRoute =
  ProtectedAuditorClientsIndexLazyRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => ProtectedAuditorRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdRoute =
  ProtectedAuditorClientsIdRouteImport.update({
    id: '/clients/$id',
    path: '/clients/$id',
    getParentRoute: () => ProtectedAuditorRouteRoute,
  } as any)
const ProtectedAuditorValidationIndexLazyRoute =
  ProtectedAuditorValidationIndexLazyRouteImport.update({
    id: '/validation/',
    path: '/validation/',
    getParentRoute: () => ProtectedAuditorRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/validation/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorValidationCreateLazyRoute =
  ProtectedAuditorValidationCreateLazyRouteImport.update({
    id: '/validation/create',
    path: '/validation/create',
    getParentRoute: () => ProtectedAuditorRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/validation/create.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIndexLazyRoute =
  ProtectedCorporateFinanceProjectsIndexLazyRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => ProtectedCorporateFinanceRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdRoute =
  ProtectedCorporateFinanceProjectsIdRouteImport.update({
    id: '/projects/$id',
    path: '/projects/$id',
    getParentRoute: () => ProtectedCorporateFinanceRouteRoute,
  } as any)
const ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute =
  ProtectedCorporateFinanceTaxonomiesTaxonomyIdRouteImport.update({
    id: '/taxonomies/$taxonomyId',
    path: '/taxonomies/$taxonomyId',
    getParentRoute: () => ProtectedCorporateFinanceRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/taxonomies/$taxonomyId.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceValidationIndexRoute =
  ProtectedCorporateFinanceValidationIndexRouteImport.update({
    id: '/validation/',
    path: '/validation/',
    getParentRoute: () => ProtectedCorporateFinanceRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/validation/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDocumentAnalysisCreateIndexRoute =
  ProtectedDocumentAnalysisCreateIndexRouteImport.update({
    id: '/document-analysis/create/',
    path: '/document-analysis/create/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/document-analysis/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedFasProjectsIndexLazyRoute =
  ProtectedFasProjectsIndexLazyRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => ProtectedFasRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/projects/index.lazy').then((d) => d.Route),
  )
const ProtectedFasProjectsIdRoute = ProtectedFasProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => ProtectedFasRouteRoute,
} as any)
const ProtectedFasTaxonomiesTaxonomyIdRoute =
  ProtectedFasTaxonomiesTaxonomyIdRouteImport.update({
    id: '/taxonomies/$taxonomyId',
    path: '/taxonomies/$taxonomyId',
    getParentRoute: () => ProtectedFasRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/taxonomies/$taxonomyId.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterAdminArticlesLazyRoute =
  ProtectedHelpCenterAdminArticlesLazyRouteImport.update({
    id: '/articles',
    path: '/articles',
    getParentRoute: () => ProtectedHelpCenterAdminRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/admin/articles.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterAdminFaqsLazyRoute =
  ProtectedHelpCenterAdminFaqsLazyRouteImport.update({
    id: '/faqs',
    path: '/faqs',
    getParentRoute: () => ProtectedHelpCenterAdminRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/admin/faqs.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterAdminReleaseNotesLazyRoute =
  ProtectedHelpCenterAdminReleaseNotesLazyRouteImport.update({
    id: '/release-notes',
    path: '/release-notes',
    getParentRoute: () => ProtectedHelpCenterAdminRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/admin/release-notes.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterAdminTemplatesLazyRoute =
  ProtectedHelpCenterAdminTemplatesLazyRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => ProtectedHelpCenterAdminRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/admin/templates.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterAdminTopicsLazyRoute =
  ProtectedHelpCenterAdminTopicsLazyRouteImport.update({
    id: '/topics',
    path: '/topics',
    getParentRoute: () => ProtectedHelpCenterAdminRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/admin/topics.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterArticlesIndexRoute =
  ProtectedHelpCenterArticlesIndexRouteImport.update({
    id: '/help-center/articles/',
    path: '/help-center/articles/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/articles/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterArticlesNewRoute =
  ProtectedHelpCenterArticlesNewRouteImport.update({
    id: '/help-center/articles/new',
    path: '/help-center/articles/new',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/articles/new.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterFaqIndexLazyRoute =
  ProtectedHelpCenterFaqIndexLazyRouteImport.update({
    id: '/help-center/faq/',
    path: '/help-center/faq/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/faq/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterReleaseNotesIndexLazyRoute =
  ProtectedHelpCenterReleaseNotesIndexLazyRouteImport.update({
    id: '/help-center/release-notes/',
    path: '/help-center/release-notes/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/release-notes/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterReleaseNotesNewLazyRoute =
  ProtectedHelpCenterReleaseNotesNewLazyRouteImport.update({
    id: '/help-center/release-notes/new',
    path: '/help-center/release-notes/new',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/release-notes/new.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterSearchIndexRoute =
  ProtectedHelpCenterSearchIndexRouteImport.update({
    id: '/help-center/search/',
    path: '/help-center/search/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedOrganizationOrgIdIndexRoute =
  ProtectedOrganizationOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdReviewRoute =
  ProtectedOrganizationOrgIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/review.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUsageIndexRoute =
  ProtectedSuperuserUsageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSuperuserUsageLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/usage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUsageConversationsLazyRoute =
  ProtectedSuperuserUsageConversationsLazyRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => ProtectedSuperuserUsageLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/usage/conversations.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUsageSessionsRoute =
  ProtectedSuperuserUsageSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => ProtectedSuperuserUsageLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/usage/sessions.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUserIdRoute =
  ProtectedSuperuserUserIdRouteImport.update({
    id: '/user/$id',
    path: '/user/$id',
    getParentRoute: () => ProtectedSuperuserRouteRoute,
  } as any)
const ProtectedTemplateEditorStatementTreesTaxonomyIdRoute =
  ProtectedTemplateEditorStatementTreesTaxonomyIdRouteImport.update({
    id: '/$taxonomyId',
    path: '/$taxonomyId',
    getParentRoute: () => ProtectedTemplateEditorStatementTreesRouteRoute,
  } as any)
const ProtectedTemplateEditorStatementTreesNewRoute =
  ProtectedTemplateEditorStatementTreesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedTemplateEditorStatementTreesRouteRoute,
  } as any)
const ProtectedWorkflowsRunIndexRoute =
  ProtectedWorkflowsRunIndexRouteImport.update({
    id: '/workflows_/run/',
    path: '/workflows/run/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/workflows_/run/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwLazyRoute =
  ProtectedAuditorClientsIdAgbwLazyRouteImport.update({
    id: '/_agbw',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_agbw.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsLazyRoute =
  ProtectedAuditorClientsIdClientTabsLazyRouteImport.update({
    id: '/_client-tabs',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwRoute =
  ProtectedAuditorClientsIdAgbwRouteImport.update({
    id: '/agbw',
    path: '/agbw',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any)
const ProtectedAuditorClientsIdAgbwResultsRoute =
  ProtectedAuditorClientsIdAgbwResultsRouteImport.update({
    id: '/agbw-results',
    path: '/agbw-results',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/agbw-results.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorValidationIdIndexLazyRoute =
  ProtectedAuditorValidationIdIndexLazyRouteImport.update({
    id: '/validation/$id/',
    path: '/validation/$id/',
    getParentRoute: () => ProtectedAuditorRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/validation/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteImport.update({
    id: '/_project-tabs',
    getParentRoute: () => ProtectedCorporateFinanceProjectsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdAccountMappingRoute =
  ProtectedCorporateFinanceProjectsIdAccountMappingRouteImport.update({
    id: '/account-mapping',
    path: '/account-mapping',
    getParentRoute: () => ProtectedCorporateFinanceProjectsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/account-mapping.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedFasProjectsIdProjectTabsLazyRoute =
  ProtectedFasProjectsIdProjectTabsLazyRouteImport.update({
    id: '/_project-tabs',
    getParentRoute: () => ProtectedFasProjectsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/projects/$id/_project-tabs.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedFasProjectsIdAccountMappingLazyRoute =
  ProtectedFasProjectsIdAccountMappingLazyRouteImport.update({
    id: '/account-mapping',
    path: '/account-mapping',
    getParentRoute: () => ProtectedFasProjectsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/projects/$id/account-mapping.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterArticlesIdIndexLazyRoute =
  ProtectedHelpCenterArticlesIdIndexLazyRouteImport.update({
    id: '/help-center/articles/$id/',
    path: '/help-center/articles/$id/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/articles/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterArticlesIdEditRoute =
  ProtectedHelpCenterArticlesIdEditRouteImport.update({
    id: '/help-center/articles/$id/edit',
    path: '/help-center/articles/$id/edit',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/articles/$id/edit.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterReleaseNotesIdIndexLazyRoute =
  ProtectedHelpCenterReleaseNotesIdIndexLazyRouteImport.update({
    id: '/help-center/release-notes/$id/',
    path: '/help-center/release-notes/$id/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/release-notes/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedHelpCenterReleaseNotesIdEditLazyRoute =
  ProtectedHelpCenterReleaseNotesIdEditLazyRouteImport.update({
    id: '/help-center/release-notes/$id/edit',
    path: '/help-center/release-notes/$id/edit',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/help-center/release-notes/$id/edit.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute =
  ProtectedOrganizationOrgIdDepartmentsIndexLazyRouteImport.update({
    id: '/departments/',
    path: '/departments/',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/departments/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdInvitationsIndexLazyRoute =
  ProtectedOrganizationOrgIdInvitationsIndexLazyRouteImport.update({
    id: '/invitations/',
    path: '/invitations/',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/invitations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdTrainingIndexLazyRoute =
  ProtectedOrganizationOrgIdTrainingIndexLazyRouteImport.update({
    id: '/training/',
    path: '/training/',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/training/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdUsersIndexLazyRoute =
  ProtectedOrganizationOrgIdUsersIndexLazyRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/users/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute =
  ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteImport.update({
    id: '/organization/$orgId_/department/$departmentId',
    path: '/organization/$orgId/department/$departmentId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedOrganizationOrgIdReviewSessionIdLazyRoute =
  ProtectedOrganizationOrgIdReviewSessionIdLazyRouteImport.update({
    id: '/organization/$orgId_/review/$sessionId',
    path: '/organization/$orgId/review/$sessionId',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId_.review.$sessionId.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUsageSessionsSessionIdLazyRoute =
  ProtectedSuperuserUsageSessionsSessionIdLazyRouteImport.update({
    id: '/usage_/sessions/$sessionId',
    path: '/usage/sessions/$sessionId',
    getParentRoute: () => ProtectedSuperuserRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/usage_.sessions.$sessionId.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUserIdPermissionsLazyRoute =
  ProtectedSuperuserUserIdPermissionsLazyRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => ProtectedSuperuserUserIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/user/$id/permissions.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedSuperuserUserIdRolesLazyRoute =
  ProtectedSuperuserUserIdRolesLazyRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => ProtectedSuperuserUserIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/superuser/user/$id/roles.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute =
  ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRouteImport.update(
    {
      id: '/template-editor/classification-templates/$templateId/create-version',
      path: '/template-editor/classification-templates/$templateId/create-version',
      getParentRoute: () => ProtectedRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/template-editor/classification-templates/$templateId/create-version.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute =
  ProtectedTemplateEditorClassificationTemplatesCreateIndexRouteImport.update({
    id: '/template-editor/classification-templates/create/',
    path: '/template-editor/classification-templates/create/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/template-editor/classification-templates/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute =
  ProtectedAuditorClientsIdAgbwAffiliatesLazyRouteImport.update({
    id: '/affiliates',
    path: '/affiliates',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_agbw/affiliates.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwBatchesLazyRoute =
  ProtectedAuditorClientsIdAgbwBatchesLazyRouteImport.update({
    id: '/batches',
    path: '/batches',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_agbw/batches.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwCamtLazyRoute =
  ProtectedAuditorClientsIdAgbwCamtLazyRouteImport.update({
    id: '/camt',
    path: '/camt',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_agbw/camt.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwMetadataRoute =
  ProtectedAuditorClientsIdAgbwMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_agbw/metadata.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute =
  ProtectedAuditorClientsIdAgbwTrialBalanceLazyRouteImport.update({
    id: '/trial-balance',
    path: '/trial-balance',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_agbw/trial-balance.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsIndexLazyRoute =
  ProtectedAuditorClientsIdClientTabsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute =
  ProtectedAuditorClientsIdClientTabsAgbwOverviewRouteImport.update({
    id: '/agbw-overview',
    path: '/agbw-overview',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/agbw-overview.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute =
  ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRouteImport.update(
    {
      id: '/continuous-auditor-results',
      path: '/continuous-auditor-results',
      getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute =
  ProtectedAuditorClientsIdClientTabsDocumentAnalysisRouteImport.update({
    id: '/document-analysis',
    path: '/document-analysis',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/document-analysis.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute =
  ProtectedAuditorClientsIdClientTabsFinancialExplorerRouteImport.update({
    id: '/financial-explorer',
    path: '/financial-explorer',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/financial-explorer.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessRouteImport.update({
    id: '/input-process',
    path: '/input-process',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsTasksRoute =
  ProtectedAuditorClientsIdClientTabsTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/tasks.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsValidationsRoute =
  ProtectedAuditorClientsIdClientTabsValidationsRouteImport.update({
    id: '/validations',
    path: '/validations',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/validations.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute =
  ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRouteImport.update({
    id: '/fraud-with-payments',
    path: '/fraud-with-payments',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwResultsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/agbw-results/fraud-with-payments.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute =
  ProtectedAuditorClientsIdAgbwResultsMiscellaneousRouteImport.update({
    id: '/miscellaneous',
    path: '/miscellaneous',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwResultsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/agbw-results/miscellaneous.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute =
  ProtectedAuditorClientsIdAgbwResultsOverviewLazyRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwResultsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/agbw-results/overview.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute =
  ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRouteImport.update({
    id: '/wwft-corruption',
    path: '/wwft-corruption',
    getParentRoute: () => ProtectedAuditorClientsIdAgbwResultsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/agbw-results/wwft-corruption.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAnalysisRidRoute =
  ProtectedAuditorClientsIdAnalysisRidRouteImport.update({
    id: '/analysis/$rid',
    path: '/analysis/$rid',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any)
const ProtectedAuditorClientsIdClassificationsEditorRoute =
  ProtectedAuditorClientsIdClassificationsEditorRouteImport.update({
    id: '/classifications/editor',
    path: '/classifications/editor',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/classifications/editor.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRouteImport.update(
    {
      id: '/document-analysis',
      path: '/document-analysis',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/document-analysis.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRouteImport.update(
    {
      id: '/financial-explorer',
      path: '/financial-explorer',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/financial-explorer.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteImport.update({
    id: '/input-process',
    path: '/input-process',
    getParentRoute: () =>
      ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRouteImport.update(
    {
      id: '/workflows',
      path: '/workflows',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/workflows.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdAnalysisRidRoute =
  ProtectedCorporateFinanceProjectsIdAnalysisRidRouteImport.update({
    id: '/analysis/$rid',
    path: '/analysis/$rid',
    getParentRoute: () => ProtectedCorporateFinanceProjectsIdRoute,
  } as any)
const ProtectedFasProjectsIdProjectTabsIndexLazyRoute =
  ProtectedFasProjectsIdProjectTabsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedFasProjectsIdProjectTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/projects/$id/_project-tabs/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute =
  ProtectedFasProjectsIdProjectTabsFinancialExplorerRouteImport.update({
    id: '/financial-explorer',
    path: '/financial-explorer',
    getParentRoute: () => ProtectedFasProjectsIdProjectTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/projects/$id/_project-tabs/financial-explorer.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedFasProjectsIdProjectTabsInputProcessRoute =
  ProtectedFasProjectsIdProjectTabsInputProcessRouteImport.update({
    id: '/input-process',
    path: '/input-process',
    getParentRoute: () => ProtectedFasProjectsIdProjectTabsLazyRoute,
  } as any)
const ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute =
  ProtectedFasProjectsIdProjectTabsWorkflowsLazyRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => ProtectedFasProjectsIdProjectTabsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/fas/projects/$id/_project-tabs/workflows.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdUserUserIdIndexRoute =
  ProtectedOrganizationOrgIdUserUserIdIndexRouteImport.update({
    id: '/user/$userId/',
    path: '/user/$userId/',
    getParentRoute: () => ProtectedOrganizationOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId/user/$userId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute =
  ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId_.department.$departmentId.index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute =
  ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRouteImport.update(
    {
      id: '/members',
      path: '/members',
      getParentRoute: () =>
        ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/organization/$orgId_.department.$departmentId.members.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute =
  ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/organization/$orgId_.department.$departmentId.review.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAuditorClientsIdClientTabsInputProcessRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessClassificationRouteImport.update(
    {
      id: '/classification',
      path: '/classification',
      getParentRoute: () =>
        ProtectedAuditorClientsIdClientTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process/classification.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRouteImport.update(
    {
      id: '/documents',
      path: '/documents',
      getParentRoute: () =>
        ProtectedAuditorClientsIdClientTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process/documents.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRouteImport.update(
    {
      id: '/reconciliation',
      path: '/reconciliation',
      getParentRoute: () =>
        ProtectedAuditorClientsIdClientTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRouteImport.update(
    {
      id: '/statement-extraction',
      path: '/statement-extraction',
      getParentRoute: () =>
        ProtectedAuditorClientsIdClientTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute =
  ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRouteImport.update(
    {
      id: '/trial-balance',
      path: '/trial-balance',
      getParentRoute: () =>
        ProtectedAuditorClientsIdClientTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/_client-tabs/input-process/trial-balance.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute =
  ProtectedAuditorClientsIdAnalysisRidResultsLazyRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => ProtectedAuditorClientsIdAnalysisRidRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/analysis/$rid/results.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAuditorClientsIdClassificationsClsIndexRoute =
  ProtectedAuditorClientsIdClassificationsClsIndexRouteImport.update({
    id: '/classifications/$cls/',
    path: '/classifications/$cls/',
    getParentRoute: () => ProtectedAuditorClientsIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/auditor/clients/$id/classifications/$cls/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRouteImport.update(
    {
      id: '/classification',
      path: '/classification',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute,
    } as any,
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRouteImport.update(
    {
      id: '/documents',
      path: '/documents',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process/documents.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRouteImport.update(
    {
      id: '/reconciliation',
      path: '/reconciliation',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process/reconciliation.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRouteImport.update(
    {
      id: '/statement-extraction',
      path: '/statement-extraction',
      getParentRoute: () =>
        ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/_project-tabs/input-process/statement-extraction.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute =
  ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => ProtectedCorporateFinanceProjectsIdAnalysisRidRoute,
  } as any).lazy(() =>
    import('./routes/_protected/corporate-finance/projects/$id/analysis/$rid/results.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute =
  ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRouteImport.update(
    {
      id: '/organization/$orgId_/department/$departmentId_/review/$sessionId',
      path: '/organization/$orgId/department/$departmentId/review/$sessionId',
      getParentRoute: () => ProtectedRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_protected/organization/$orgId_.department.$departmentId_.review.$sessionId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof ProtectedIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/auditor': typeof ProtectedAuditorRouteRouteWithChildren
  '/corporate-finance': typeof ProtectedCorporateFinanceRouteRouteWithChildren
  '/fas': typeof ProtectedFasRouteRouteWithChildren
  '/superuser': typeof ProtectedSuperuserRouteRouteWithChildren
  '/data': typeof ProtectedDataRouteWithChildren
  '/workflows': typeof ProtectedWorkflowsRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/two-fa': typeof AuthTwoFaRoute
  '/auth/two-fa-verify': typeof AuthTwoFaVerifyRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/request-verify': typeof AuthRequestVerifyLazyRoute
  '/auth/sign-up': typeof AuthSignUpLazyRoute
  '/auth/terms': typeof AuthTermsLazyRoute
  '/template-editor/statement-trees': typeof ProtectedTemplateEditorStatementTreesRouteRouteWithChildren
  '/data/collections': typeof ProtectedDataCollectionsRoute
  '/data/databases': typeof ProtectedDataDatabasesRoute
  '/data/datasources': typeof ProtectedDataDatasourcesRoute
  '/document-analysis/bulk-results': typeof ProtectedDocumentAnalysisBulkResultsRoute
  '/document-analysis/comparison': typeof ProtectedDocumentAnalysisComparisonRoute
  '/document-analysis/results': typeof ProtectedDocumentAnalysisResultsRoute
  '/help-center/admin': typeof ProtectedHelpCenterAdminRouteWithChildren
  '/organization/$orgId': typeof ProtectedOrganizationOrgIdRouteWithChildren
  '/workflows/results': typeof ProtectedWorkflowsResultsRoute
  '/workflows/schedule': typeof ProtectedWorkflowsScheduleRoute
  '/auth/workos/callback': typeof AuthWorkosCallbackRoute
  '/superuser/customers': typeof ProtectedSuperuserCustomersLazyRoute
  '/superuser/settings': typeof ProtectedSuperuserSettingsLazyRoute
  '/superuser/usage': typeof ProtectedSuperuserUsageLazyRouteWithChildren
  '/auditor/': typeof ProtectedAuditorIndexRoute
  '/document-analysis/': typeof ProtectedDocumentAnalysisIndexRoute
  '/history/': typeof ProtectedHistoryIndexRoute
  '/not-authorized/': typeof ProtectedNotAuthorizedIndexRoute
  '/report-issue/': typeof ProtectedReportIssueIndexRoute
  '/superuser/': typeof ProtectedSuperuserIndexRoute
  '/template-editor/': typeof ProtectedTemplateEditorIndexRoute
  '/workflow-editor/': typeof ProtectedWorkflowEditorIndexRoute
  '/workflows/': typeof ProtectedWorkflowsIndexRoute
  '/bi/': typeof ProtectedBiIndexLazyRoute
  '/help-center/': typeof ProtectedHelpCenterIndexLazyRoute
  '/no-organization/': typeof ProtectedNoOrganizationIndexLazyRoute
  '/settings/': typeof ProtectedSettingsIndexLazyRoute
  '/auditor/clients/$id': typeof ProtectedAuditorClientsIdClientTabsLazyRouteWithChildren
  '/corporate-finance/projects/$id': typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteWithChildren
  '/corporate-finance/taxonomies/$taxonomyId': typeof ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute
  '/fas/projects/$id': typeof ProtectedFasProjectsIdProjectTabsLazyRouteWithChildren
  '/fas/taxonomies/$taxonomyId': typeof ProtectedFasTaxonomiesTaxonomyIdRoute
  '/help-center/articles/new': typeof ProtectedHelpCenterArticlesNewRoute
  '/organization/$orgId/review': typeof ProtectedOrganizationOrgIdReviewRoute
  '/superuser/usage/sessions': typeof ProtectedSuperuserUsageSessionsRoute
  '/superuser/user/$id': typeof ProtectedSuperuserUserIdRouteWithChildren
  '/template-editor/statement-trees/$taxonomyId': typeof ProtectedTemplateEditorStatementTreesTaxonomyIdRoute
  '/template-editor/statement-trees/new': typeof ProtectedTemplateEditorStatementTreesNewRoute
  '/auditor/validation/create': typeof ProtectedAuditorValidationCreateLazyRoute
  '/help-center/admin/articles': typeof ProtectedHelpCenterAdminArticlesLazyRoute
  '/help-center/admin/faqs': typeof ProtectedHelpCenterAdminFaqsLazyRoute
  '/help-center/admin/release-notes': typeof ProtectedHelpCenterAdminReleaseNotesLazyRoute
  '/help-center/admin/templates': typeof ProtectedHelpCenterAdminTemplatesLazyRoute
  '/help-center/admin/topics': typeof ProtectedHelpCenterAdminTopicsLazyRoute
  '/help-center/release-notes/new': typeof ProtectedHelpCenterReleaseNotesNewLazyRoute
  '/superuser/usage/conversations': typeof ProtectedSuperuserUsageConversationsLazyRoute
  '/corporate-finance/validation/': typeof ProtectedCorporateFinanceValidationIndexRoute
  '/document-analysis/create/': typeof ProtectedDocumentAnalysisCreateIndexRoute
  '/help-center/articles/': typeof ProtectedHelpCenterArticlesIndexRoute
  '/help-center/search/': typeof ProtectedHelpCenterSearchIndexRoute
  '/organization/$orgId/': typeof ProtectedOrganizationOrgIdIndexRoute
  '/superuser/usage/': typeof ProtectedSuperuserUsageIndexRoute
  '/workflows/run/': typeof ProtectedWorkflowsRunIndexRoute
  '/auditor/clients/': typeof ProtectedAuditorClientsIndexLazyRoute
  '/auditor/validation/': typeof ProtectedAuditorValidationIndexLazyRoute
  '/corporate-finance/projects/': typeof ProtectedCorporateFinanceProjectsIndexLazyRoute
  '/fas/projects/': typeof ProtectedFasProjectsIndexLazyRoute
  '/help-center/faq/': typeof ProtectedHelpCenterFaqIndexLazyRoute
  '/help-center/release-notes/': typeof ProtectedHelpCenterReleaseNotesIndexLazyRoute
  '/auditor/clients/$id/agbw': typeof ProtectedAuditorClientsIdAgbwRoute
  '/auditor/clients/$id/agbw-results': typeof ProtectedAuditorClientsIdAgbwResultsRouteWithChildren
  '/corporate-finance/projects/$id/account-mapping': typeof ProtectedCorporateFinanceProjectsIdAccountMappingRoute
  '/help-center/articles/$id/edit': typeof ProtectedHelpCenterArticlesIdEditRoute
  '/organization/$orgId/department/$departmentId': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteWithChildren
  '/template-editor/classification-templates/$templateId/create-version': typeof ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute
  '/fas/projects/$id/account-mapping': typeof ProtectedFasProjectsIdAccountMappingLazyRoute
  '/help-center/release-notes/$id/edit': typeof ProtectedHelpCenterReleaseNotesIdEditLazyRoute
  '/organization/$orgId/review/$sessionId': typeof ProtectedOrganizationOrgIdReviewSessionIdLazyRoute
  '/superuser/usage/sessions/$sessionId': typeof ProtectedSuperuserUsageSessionsSessionIdLazyRoute
  '/superuser/user/$id/permissions': typeof ProtectedSuperuserUserIdPermissionsLazyRoute
  '/superuser/user/$id/roles': typeof ProtectedSuperuserUserIdRolesLazyRoute
  '/template-editor/classification-templates/create/': typeof ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute
  '/auditor/validation/$id/': typeof ProtectedAuditorValidationIdIndexLazyRoute
  '/help-center/articles/$id/': typeof ProtectedHelpCenterArticlesIdIndexLazyRoute
  '/help-center/release-notes/$id/': typeof ProtectedHelpCenterReleaseNotesIdIndexLazyRoute
  '/organization/$orgId/departments/': typeof ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute
  '/organization/$orgId/invitations/': typeof ProtectedOrganizationOrgIdInvitationsIndexLazyRoute
  '/organization/$orgId/training/': typeof ProtectedOrganizationOrgIdTrainingIndexLazyRoute
  '/organization/$orgId/users/': typeof ProtectedOrganizationOrgIdUsersIndexLazyRoute
  '/auditor/clients/$id/metadata': typeof ProtectedAuditorClientsIdAgbwMetadataRoute
  '/auditor/clients/$id/agbw-overview': typeof ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute
  '/auditor/clients/$id/continuous-auditor-results': typeof ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute
  '/auditor/clients/$id/document-analysis': typeof ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute
  '/auditor/clients/$id/financial-explorer': typeof ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute
  '/auditor/clients/$id/input-process': typeof ProtectedAuditorClientsIdClientTabsInputProcessRouteWithChildren
  '/auditor/clients/$id/tasks': typeof ProtectedAuditorClientsIdClientTabsTasksRoute
  '/auditor/clients/$id/validations': typeof ProtectedAuditorClientsIdClientTabsValidationsRoute
  '/auditor/clients/$id/agbw-results/fraud-with-payments': typeof ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute
  '/auditor/clients/$id/agbw-results/miscellaneous': typeof ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute
  '/auditor/clients/$id/agbw-results/wwft-corruption': typeof ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute
  '/auditor/clients/$id/analysis/$rid': typeof ProtectedAuditorClientsIdAnalysisRidRouteWithChildren
  '/auditor/clients/$id/classifications/editor': typeof ProtectedAuditorClientsIdClassificationsEditorRoute
  '/corporate-finance/projects/$id/financial-explorer': typeof ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute
  '/corporate-finance/projects/$id/input-process': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteWithChildren
  '/corporate-finance/projects/$id/analysis/$rid': typeof ProtectedCorporateFinanceProjectsIdAnalysisRidRouteWithChildren
  '/fas/projects/$id/financial-explorer': typeof ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute
  '/fas/projects/$id/input-process': typeof ProtectedFasProjectsIdProjectTabsInputProcessRoute
  '/organization/$orgId/department/$departmentId/review': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute
  '/auditor/clients/$id/affiliates': typeof ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute
  '/auditor/clients/$id/batches': typeof ProtectedAuditorClientsIdAgbwBatchesLazyRoute
  '/auditor/clients/$id/camt': typeof ProtectedAuditorClientsIdAgbwCamtLazyRoute
  '/auditor/clients/$id/trial-balance': typeof ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute
  '/auditor/clients/$id/agbw-results/overview': typeof ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute
  '/corporate-finance/projects/$id/document-analysis': typeof ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute
  '/corporate-finance/projects/$id/workflows': typeof ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute
  '/fas/projects/$id/workflows': typeof ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute
  '/organization/$orgId/department/$departmentId/members': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute
  '/organization/$orgId/user/$userId/': typeof ProtectedOrganizationOrgIdUserUserIdIndexRoute
  '/auditor/clients/$id/': typeof ProtectedAuditorClientsIdClientTabsIndexLazyRoute
  '/corporate-finance/projects/$id/': typeof ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute
  '/fas/projects/$id/': typeof ProtectedFasProjectsIdProjectTabsIndexLazyRoute
  '/organization/$orgId/department/$departmentId/': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute
  '/auditor/clients/$id/input-process/classification': typeof ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute
  '/auditor/clients/$id/input-process/reconciliation': typeof ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute
  '/auditor/clients/$id/input-process/statement-extraction': typeof ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute
  '/corporate-finance/projects/$id/input-process/classification': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute
  '/auditor/clients/$id/input-process/documents': typeof ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute
  '/auditor/clients/$id/input-process/trial-balance': typeof ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute
  '/auditor/clients/$id/analysis/$rid/results': typeof ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute
  '/corporate-finance/projects/$id/input-process/documents': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute
  '/corporate-finance/projects/$id/input-process/reconciliation': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute
  '/corporate-finance/projects/$id/input-process/statement-extraction': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute
  '/corporate-finance/projects/$id/analysis/$rid/results': typeof ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute
  '/organization/$orgId/department/$departmentId/review/$sessionId': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute
  '/auditor/clients/$id/classifications/$cls/': typeof ProtectedAuditorClientsIdClassificationsClsIndexRoute
  '/auditor/clients/$id/input-process/': typeof ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute
  '/corporate-finance/projects/$id/input-process/': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/corporate-finance': typeof ProtectedCorporateFinanceRouteRouteWithChildren
  '/fas': typeof ProtectedFasRouteRouteWithChildren
  '/data': typeof ProtectedDataRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/two-fa': typeof AuthTwoFaRoute
  '/auth/two-fa-verify': typeof AuthTwoFaVerifyRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/request-verify': typeof AuthRequestVerifyLazyRoute
  '/auth/sign-up': typeof AuthSignUpLazyRoute
  '/auth/terms': typeof AuthTermsLazyRoute
  '/': typeof ProtectedIndexRoute
  '/template-editor/statement-trees': typeof ProtectedTemplateEditorStatementTreesRouteRouteWithChildren
  '/data/collections': typeof ProtectedDataCollectionsRoute
  '/data/databases': typeof ProtectedDataDatabasesRoute
  '/data/datasources': typeof ProtectedDataDatasourcesRoute
  '/document-analysis/bulk-results': typeof ProtectedDocumentAnalysisBulkResultsRoute
  '/document-analysis/comparison': typeof ProtectedDocumentAnalysisComparisonRoute
  '/document-analysis/results': typeof ProtectedDocumentAnalysisResultsRoute
  '/help-center/admin': typeof ProtectedHelpCenterAdminRouteWithChildren
  '/workflows/results': typeof ProtectedWorkflowsResultsRoute
  '/workflows/schedule': typeof ProtectedWorkflowsScheduleRoute
  '/auth/workos/callback': typeof AuthWorkosCallbackRoute
  '/superuser/customers': typeof ProtectedSuperuserCustomersLazyRoute
  '/superuser/settings': typeof ProtectedSuperuserSettingsLazyRoute
  '/auditor': typeof ProtectedAuditorIndexRoute
  '/document-analysis': typeof ProtectedDocumentAnalysisIndexRoute
  '/history': typeof ProtectedHistoryIndexRoute
  '/not-authorized': typeof ProtectedNotAuthorizedIndexRoute
  '/report-issue': typeof ProtectedReportIssueIndexRoute
  '/superuser': typeof ProtectedSuperuserIndexRoute
  '/template-editor': typeof ProtectedTemplateEditorIndexRoute
  '/workflow-editor': typeof ProtectedWorkflowEditorIndexRoute
  '/workflows': typeof ProtectedWorkflowsIndexRoute
  '/bi': typeof ProtectedBiIndexLazyRoute
  '/help-center': typeof ProtectedHelpCenterIndexLazyRoute
  '/no-organization': typeof ProtectedNoOrganizationIndexLazyRoute
  '/settings': typeof ProtectedSettingsIndexLazyRoute
  '/auditor/clients/$id': typeof ProtectedAuditorClientsIdClientTabsIndexLazyRoute
  '/corporate-finance/projects/$id': typeof ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute
  '/corporate-finance/taxonomies/$taxonomyId': typeof ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute
  '/fas/projects/$id': typeof ProtectedFasProjectsIdProjectTabsIndexLazyRoute
  '/fas/taxonomies/$taxonomyId': typeof ProtectedFasTaxonomiesTaxonomyIdRoute
  '/help-center/articles/new': typeof ProtectedHelpCenterArticlesNewRoute
  '/organization/$orgId/review': typeof ProtectedOrganizationOrgIdReviewRoute
  '/superuser/usage/sessions': typeof ProtectedSuperuserUsageSessionsRoute
  '/superuser/user/$id': typeof ProtectedSuperuserUserIdRouteWithChildren
  '/template-editor/statement-trees/$taxonomyId': typeof ProtectedTemplateEditorStatementTreesTaxonomyIdRoute
  '/template-editor/statement-trees/new': typeof ProtectedTemplateEditorStatementTreesNewRoute
  '/auditor/validation/create': typeof ProtectedAuditorValidationCreateLazyRoute
  '/help-center/admin/articles': typeof ProtectedHelpCenterAdminArticlesLazyRoute
  '/help-center/admin/faqs': typeof ProtectedHelpCenterAdminFaqsLazyRoute
  '/help-center/admin/release-notes': typeof ProtectedHelpCenterAdminReleaseNotesLazyRoute
  '/help-center/admin/templates': typeof ProtectedHelpCenterAdminTemplatesLazyRoute
  '/help-center/admin/topics': typeof ProtectedHelpCenterAdminTopicsLazyRoute
  '/help-center/release-notes/new': typeof ProtectedHelpCenterReleaseNotesNewLazyRoute
  '/superuser/usage/conversations': typeof ProtectedSuperuserUsageConversationsLazyRoute
  '/corporate-finance/validation': typeof ProtectedCorporateFinanceValidationIndexRoute
  '/document-analysis/create': typeof ProtectedDocumentAnalysisCreateIndexRoute
  '/help-center/articles': typeof ProtectedHelpCenterArticlesIndexRoute
  '/help-center/search': typeof ProtectedHelpCenterSearchIndexRoute
  '/organization/$orgId': typeof ProtectedOrganizationOrgIdIndexRoute
  '/superuser/usage': typeof ProtectedSuperuserUsageIndexRoute
  '/workflows/run': typeof ProtectedWorkflowsRunIndexRoute
  '/auditor/clients': typeof ProtectedAuditorClientsIndexLazyRoute
  '/auditor/validation': typeof ProtectedAuditorValidationIndexLazyRoute
  '/corporate-finance/projects': typeof ProtectedCorporateFinanceProjectsIndexLazyRoute
  '/fas/projects': typeof ProtectedFasProjectsIndexLazyRoute
  '/help-center/faq': typeof ProtectedHelpCenterFaqIndexLazyRoute
  '/help-center/release-notes': typeof ProtectedHelpCenterReleaseNotesIndexLazyRoute
  '/auditor/clients/$id/agbw': typeof ProtectedAuditorClientsIdAgbwRoute
  '/auditor/clients/$id/agbw-results': typeof ProtectedAuditorClientsIdAgbwResultsRouteWithChildren
  '/corporate-finance/projects/$id/account-mapping': typeof ProtectedCorporateFinanceProjectsIdAccountMappingRoute
  '/help-center/articles/$id/edit': typeof ProtectedHelpCenterArticlesIdEditRoute
  '/template-editor/classification-templates/$templateId/create-version': typeof ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute
  '/fas/projects/$id/account-mapping': typeof ProtectedFasProjectsIdAccountMappingLazyRoute
  '/help-center/release-notes/$id/edit': typeof ProtectedHelpCenterReleaseNotesIdEditLazyRoute
  '/organization/$orgId/review/$sessionId': typeof ProtectedOrganizationOrgIdReviewSessionIdLazyRoute
  '/superuser/usage/sessions/$sessionId': typeof ProtectedSuperuserUsageSessionsSessionIdLazyRoute
  '/superuser/user/$id/permissions': typeof ProtectedSuperuserUserIdPermissionsLazyRoute
  '/superuser/user/$id/roles': typeof ProtectedSuperuserUserIdRolesLazyRoute
  '/template-editor/classification-templates/create': typeof ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute
  '/auditor/validation/$id': typeof ProtectedAuditorValidationIdIndexLazyRoute
  '/help-center/articles/$id': typeof ProtectedHelpCenterArticlesIdIndexLazyRoute
  '/help-center/release-notes/$id': typeof ProtectedHelpCenterReleaseNotesIdIndexLazyRoute
  '/organization/$orgId/departments': typeof ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute
  '/organization/$orgId/invitations': typeof ProtectedOrganizationOrgIdInvitationsIndexLazyRoute
  '/organization/$orgId/training': typeof ProtectedOrganizationOrgIdTrainingIndexLazyRoute
  '/organization/$orgId/users': typeof ProtectedOrganizationOrgIdUsersIndexLazyRoute
  '/auditor/clients/$id/metadata': typeof ProtectedAuditorClientsIdAgbwMetadataRoute
  '/auditor/clients/$id/agbw-overview': typeof ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute
  '/auditor/clients/$id/continuous-auditor-results': typeof ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute
  '/auditor/clients/$id/document-analysis': typeof ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute
  '/auditor/clients/$id/financial-explorer': typeof ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute
  '/auditor/clients/$id/tasks': typeof ProtectedAuditorClientsIdClientTabsTasksRoute
  '/auditor/clients/$id/validations': typeof ProtectedAuditorClientsIdClientTabsValidationsRoute
  '/auditor/clients/$id/agbw-results/fraud-with-payments': typeof ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute
  '/auditor/clients/$id/agbw-results/miscellaneous': typeof ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute
  '/auditor/clients/$id/agbw-results/wwft-corruption': typeof ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute
  '/auditor/clients/$id/analysis/$rid': typeof ProtectedAuditorClientsIdAnalysisRidRouteWithChildren
  '/auditor/clients/$id/classifications/editor': typeof ProtectedAuditorClientsIdClassificationsEditorRoute
  '/corporate-finance/projects/$id/financial-explorer': typeof ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute
  '/corporate-finance/projects/$id/analysis/$rid': typeof ProtectedCorporateFinanceProjectsIdAnalysisRidRouteWithChildren
  '/fas/projects/$id/financial-explorer': typeof ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute
  '/fas/projects/$id/input-process': typeof ProtectedFasProjectsIdProjectTabsInputProcessRoute
  '/organization/$orgId/department/$departmentId/review': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute
  '/auditor/clients/$id/affiliates': typeof ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute
  '/auditor/clients/$id/batches': typeof ProtectedAuditorClientsIdAgbwBatchesLazyRoute
  '/auditor/clients/$id/camt': typeof ProtectedAuditorClientsIdAgbwCamtLazyRoute
  '/auditor/clients/$id/trial-balance': typeof ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute
  '/auditor/clients/$id/agbw-results/overview': typeof ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute
  '/corporate-finance/projects/$id/document-analysis': typeof ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute
  '/corporate-finance/projects/$id/workflows': typeof ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute
  '/fas/projects/$id/workflows': typeof ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute
  '/organization/$orgId/department/$departmentId/members': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute
  '/organization/$orgId/user/$userId': typeof ProtectedOrganizationOrgIdUserUserIdIndexRoute
  '/organization/$orgId/department/$departmentId': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute
  '/auditor/clients/$id/input-process/classification': typeof ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute
  '/auditor/clients/$id/input-process/reconciliation': typeof ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute
  '/auditor/clients/$id/input-process/statement-extraction': typeof ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute
  '/corporate-finance/projects/$id/input-process/classification': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute
  '/auditor/clients/$id/input-process/documents': typeof ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute
  '/auditor/clients/$id/input-process/trial-balance': typeof ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute
  '/auditor/clients/$id/analysis/$rid/results': typeof ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute
  '/corporate-finance/projects/$id/input-process/documents': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute
  '/corporate-finance/projects/$id/input-process/reconciliation': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute
  '/corporate-finance/projects/$id/input-process/statement-extraction': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute
  '/corporate-finance/projects/$id/analysis/$rid/results': typeof ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute
  '/organization/$orgId/department/$departmentId/review/$sessionId': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute
  '/auditor/clients/$id/classifications/$cls': typeof ProtectedAuditorClientsIdClassificationsClsIndexRoute
  '/auditor/clients/$id/input-process': typeof ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute
  '/corporate-finance/projects/$id/input-process': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_protected/auditor': typeof ProtectedAuditorRouteRouteWithChildren
  '/_protected/corporate-finance': typeof ProtectedCorporateFinanceRouteRouteWithChildren
  '/_protected/fas': typeof ProtectedFasRouteRouteWithChildren
  '/_protected/superuser': typeof ProtectedSuperuserRouteRouteWithChildren
  '/_protected/data': typeof ProtectedDataRouteWithChildren
  '/_protected/workflows': typeof ProtectedWorkflowsRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/two-fa': typeof AuthTwoFaRoute
  '/auth/two-fa-verify': typeof AuthTwoFaVerifyRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/request-verify': typeof AuthRequestVerifyLazyRoute
  '/auth/sign-up': typeof AuthSignUpLazyRoute
  '/auth/terms': typeof AuthTermsLazyRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/template-editor/statement-trees': typeof ProtectedTemplateEditorStatementTreesRouteRouteWithChildren
  '/_protected/data/collections': typeof ProtectedDataCollectionsRoute
  '/_protected/data/databases': typeof ProtectedDataDatabasesRoute
  '/_protected/data/datasources': typeof ProtectedDataDatasourcesRoute
  '/_protected/document-analysis/bulk-results': typeof ProtectedDocumentAnalysisBulkResultsRoute
  '/_protected/document-analysis/comparison': typeof ProtectedDocumentAnalysisComparisonRoute
  '/_protected/document-analysis/results': typeof ProtectedDocumentAnalysisResultsRoute
  '/_protected/help-center/admin': typeof ProtectedHelpCenterAdminRouteWithChildren
  '/_protected/organization/$orgId': typeof ProtectedOrganizationOrgIdRouteWithChildren
  '/_protected/workflows/results': typeof ProtectedWorkflowsResultsRoute
  '/_protected/workflows/schedule': typeof ProtectedWorkflowsScheduleRoute
  '/auth/workos/callback': typeof AuthWorkosCallbackRoute
  '/_protected/superuser/customers': typeof ProtectedSuperuserCustomersLazyRoute
  '/_protected/superuser/settings': typeof ProtectedSuperuserSettingsLazyRoute
  '/_protected/superuser/usage': typeof ProtectedSuperuserUsageLazyRouteWithChildren
  '/_protected/auditor/': typeof ProtectedAuditorIndexRoute
  '/_protected/document-analysis/': typeof ProtectedDocumentAnalysisIndexRoute
  '/_protected/history/': typeof ProtectedHistoryIndexRoute
  '/_protected/not-authorized/': typeof ProtectedNotAuthorizedIndexRoute
  '/_protected/report-issue/': typeof ProtectedReportIssueIndexRoute
  '/_protected/superuser/': typeof ProtectedSuperuserIndexRoute
  '/_protected/template-editor/': typeof ProtectedTemplateEditorIndexRoute
  '/_protected/workflow-editor/': typeof ProtectedWorkflowEditorIndexRoute
  '/_protected/workflows/': typeof ProtectedWorkflowsIndexRoute
  '/_protected/bi/': typeof ProtectedBiIndexLazyRoute
  '/_protected/help-center/': typeof ProtectedHelpCenterIndexLazyRoute
  '/_protected/no-organization/': typeof ProtectedNoOrganizationIndexLazyRoute
  '/_protected/settings/': typeof ProtectedSettingsIndexLazyRoute
  '/_protected/auditor/clients/$id': typeof ProtectedAuditorClientsIdRouteWithChildren
  '/_protected/corporate-finance/projects/$id': typeof ProtectedCorporateFinanceProjectsIdRouteWithChildren
  '/_protected/corporate-finance/taxonomies/$taxonomyId': typeof ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute
  '/_protected/fas/projects/$id': typeof ProtectedFasProjectsIdRouteWithChildren
  '/_protected/fas/taxonomies/$taxonomyId': typeof ProtectedFasTaxonomiesTaxonomyIdRoute
  '/_protected/help-center/articles/new': typeof ProtectedHelpCenterArticlesNewRoute
  '/_protected/organization/$orgId/review': typeof ProtectedOrganizationOrgIdReviewRoute
  '/_protected/superuser/usage/sessions': typeof ProtectedSuperuserUsageSessionsRoute
  '/_protected/superuser/user/$id': typeof ProtectedSuperuserUserIdRouteWithChildren
  '/_protected/template-editor/statement-trees/$taxonomyId': typeof ProtectedTemplateEditorStatementTreesTaxonomyIdRoute
  '/_protected/template-editor/statement-trees/new': typeof ProtectedTemplateEditorStatementTreesNewRoute
  '/_protected/auditor/validation/create': typeof ProtectedAuditorValidationCreateLazyRoute
  '/_protected/help-center/admin/articles': typeof ProtectedHelpCenterAdminArticlesLazyRoute
  '/_protected/help-center/admin/faqs': typeof ProtectedHelpCenterAdminFaqsLazyRoute
  '/_protected/help-center/admin/release-notes': typeof ProtectedHelpCenterAdminReleaseNotesLazyRoute
  '/_protected/help-center/admin/templates': typeof ProtectedHelpCenterAdminTemplatesLazyRoute
  '/_protected/help-center/admin/topics': typeof ProtectedHelpCenterAdminTopicsLazyRoute
  '/_protected/help-center/release-notes/new': typeof ProtectedHelpCenterReleaseNotesNewLazyRoute
  '/_protected/superuser/usage/conversations': typeof ProtectedSuperuserUsageConversationsLazyRoute
  '/_protected/corporate-finance/validation/': typeof ProtectedCorporateFinanceValidationIndexRoute
  '/_protected/document-analysis/create/': typeof ProtectedDocumentAnalysisCreateIndexRoute
  '/_protected/help-center/articles/': typeof ProtectedHelpCenterArticlesIndexRoute
  '/_protected/help-center/search/': typeof ProtectedHelpCenterSearchIndexRoute
  '/_protected/organization/$orgId/': typeof ProtectedOrganizationOrgIdIndexRoute
  '/_protected/superuser/usage/': typeof ProtectedSuperuserUsageIndexRoute
  '/_protected/workflows_/run/': typeof ProtectedWorkflowsRunIndexRoute
  '/_protected/auditor/clients/': typeof ProtectedAuditorClientsIndexLazyRoute
  '/_protected/auditor/validation/': typeof ProtectedAuditorValidationIndexLazyRoute
  '/_protected/corporate-finance/projects/': typeof ProtectedCorporateFinanceProjectsIndexLazyRoute
  '/_protected/fas/projects/': typeof ProtectedFasProjectsIndexLazyRoute
  '/_protected/help-center/faq/': typeof ProtectedHelpCenterFaqIndexLazyRoute
  '/_protected/help-center/release-notes/': typeof ProtectedHelpCenterReleaseNotesIndexLazyRoute
  '/_protected/auditor/clients/$id/agbw': typeof ProtectedAuditorClientsIdAgbwRoute
  '/_protected/auditor/clients/$id/agbw-results': typeof ProtectedAuditorClientsIdAgbwResultsRouteWithChildren
  '/_protected/corporate-finance/projects/$id/account-mapping': typeof ProtectedCorporateFinanceProjectsIdAccountMappingRoute
  '/_protected/help-center/articles/$id/edit': typeof ProtectedHelpCenterArticlesIdEditRoute
  '/_protected/organization/$orgId_/department/$departmentId': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteWithChildren
  '/_protected/template-editor/classification-templates/$templateId/create-version': typeof ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute
  '/_protected/auditor/clients/$id/_agbw': typeof ProtectedAuditorClientsIdAgbwLazyRouteWithChildren
  '/_protected/auditor/clients/$id/_client-tabs': typeof ProtectedAuditorClientsIdClientTabsLazyRouteWithChildren
  '/_protected/corporate-finance/projects/$id/_project-tabs': typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteWithChildren
  '/_protected/fas/projects/$id/_project-tabs': typeof ProtectedFasProjectsIdProjectTabsLazyRouteWithChildren
  '/_protected/fas/projects/$id/account-mapping': typeof ProtectedFasProjectsIdAccountMappingLazyRoute
  '/_protected/help-center/release-notes/$id/edit': typeof ProtectedHelpCenterReleaseNotesIdEditLazyRoute
  '/_protected/organization/$orgId_/review/$sessionId': typeof ProtectedOrganizationOrgIdReviewSessionIdLazyRoute
  '/_protected/superuser/usage_/sessions/$sessionId': typeof ProtectedSuperuserUsageSessionsSessionIdLazyRoute
  '/_protected/superuser/user/$id/permissions': typeof ProtectedSuperuserUserIdPermissionsLazyRoute
  '/_protected/superuser/user/$id/roles': typeof ProtectedSuperuserUserIdRolesLazyRoute
  '/_protected/template-editor/classification-templates/create/': typeof ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute
  '/_protected/auditor/validation/$id/': typeof ProtectedAuditorValidationIdIndexLazyRoute
  '/_protected/help-center/articles/$id/': typeof ProtectedHelpCenterArticlesIdIndexLazyRoute
  '/_protected/help-center/release-notes/$id/': typeof ProtectedHelpCenterReleaseNotesIdIndexLazyRoute
  '/_protected/organization/$orgId/departments/': typeof ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute
  '/_protected/organization/$orgId/invitations/': typeof ProtectedOrganizationOrgIdInvitationsIndexLazyRoute
  '/_protected/organization/$orgId/training/': typeof ProtectedOrganizationOrgIdTrainingIndexLazyRoute
  '/_protected/organization/$orgId/users/': typeof ProtectedOrganizationOrgIdUsersIndexLazyRoute
  '/_protected/auditor/clients/$id/_agbw/metadata': typeof ProtectedAuditorClientsIdAgbwMetadataRoute
  '/_protected/auditor/clients/$id/_client-tabs/agbw-overview': typeof ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute
  '/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results': typeof ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute
  '/_protected/auditor/clients/$id/_client-tabs/document-analysis': typeof ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute
  '/_protected/auditor/clients/$id/_client-tabs/financial-explorer': typeof ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process': typeof ProtectedAuditorClientsIdClientTabsInputProcessRouteWithChildren
  '/_protected/auditor/clients/$id/_client-tabs/tasks': typeof ProtectedAuditorClientsIdClientTabsTasksRoute
  '/_protected/auditor/clients/$id/_client-tabs/validations': typeof ProtectedAuditorClientsIdClientTabsValidationsRoute
  '/_protected/auditor/clients/$id/agbw-results/fraud-with-payments': typeof ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute
  '/_protected/auditor/clients/$id/agbw-results/miscellaneous': typeof ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute
  '/_protected/auditor/clients/$id/agbw-results/wwft-corruption': typeof ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute
  '/_protected/auditor/clients/$id/analysis/$rid': typeof ProtectedAuditorClientsIdAnalysisRidRouteWithChildren
  '/_protected/auditor/clients/$id/classifications/editor': typeof ProtectedAuditorClientsIdClassificationsEditorRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/financial-explorer': typeof ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/input-process': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteWithChildren
  '/_protected/corporate-finance/projects/$id/analysis/$rid': typeof ProtectedCorporateFinanceProjectsIdAnalysisRidRouteWithChildren
  '/_protected/fas/projects/$id/_project-tabs/financial-explorer': typeof ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute
  '/_protected/fas/projects/$id/_project-tabs/input-process': typeof ProtectedFasProjectsIdProjectTabsInputProcessRoute
  '/_protected/organization/$orgId_/department/$departmentId/review': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute
  '/_protected/auditor/clients/$id/_agbw/affiliates': typeof ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute
  '/_protected/auditor/clients/$id/_agbw/batches': typeof ProtectedAuditorClientsIdAgbwBatchesLazyRoute
  '/_protected/auditor/clients/$id/_agbw/camt': typeof ProtectedAuditorClientsIdAgbwCamtLazyRoute
  '/_protected/auditor/clients/$id/_agbw/trial-balance': typeof ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute
  '/_protected/auditor/clients/$id/agbw-results/overview': typeof ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/document-analysis': typeof ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/workflows': typeof ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute
  '/_protected/fas/projects/$id/_project-tabs/workflows': typeof ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute
  '/_protected/organization/$orgId_/department/$departmentId/members': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute
  '/_protected/organization/$orgId/user/$userId/': typeof ProtectedOrganizationOrgIdUserUserIdIndexRoute
  '/_protected/auditor/clients/$id/_client-tabs/': typeof ProtectedAuditorClientsIdClientTabsIndexLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/': typeof ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute
  '/_protected/fas/projects/$id/_project-tabs/': typeof ProtectedFasProjectsIdProjectTabsIndexLazyRoute
  '/_protected/organization/$orgId_/department/$departmentId/': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process/classification': typeof ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation': typeof ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction': typeof ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/classification': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process/documents': typeof ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process/trial-balance': typeof ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute
  '/_protected/auditor/clients/$id/analysis/$rid/results': typeof ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/documents': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/reconciliation': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/statement-extraction': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute
  '/_protected/corporate-finance/projects/$id/analysis/$rid/results': typeof ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute
  '/_protected/organization/$orgId_/department/$departmentId_/review/$sessionId': typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute
  '/_protected/auditor/clients/$id/classifications/$cls/': typeof ProtectedAuditorClientsIdClassificationsClsIndexRoute
  '/_protected/auditor/clients/$id/_client-tabs/input-process/': typeof ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute
  '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/': typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/auditor'
    | '/corporate-finance'
    | '/fas'
    | '/superuser'
    | '/data'
    | '/workflows'
    | '/auth/change-password'
    | '/auth/forgot-password'
    | '/auth/sign-in'
    | '/auth/two-fa'
    | '/auth/two-fa-verify'
    | '/auth/verify'
    | '/auth/request-verify'
    | '/auth/sign-up'
    | '/auth/terms'
    | '/template-editor/statement-trees'
    | '/data/collections'
    | '/data/databases'
    | '/data/datasources'
    | '/document-analysis/bulk-results'
    | '/document-analysis/comparison'
    | '/document-analysis/results'
    | '/help-center/admin'
    | '/organization/$orgId'
    | '/workflows/results'
    | '/workflows/schedule'
    | '/auth/workos/callback'
    | '/superuser/customers'
    | '/superuser/settings'
    | '/superuser/usage'
    | '/auditor/'
    | '/document-analysis/'
    | '/history/'
    | '/not-authorized/'
    | '/report-issue/'
    | '/superuser/'
    | '/template-editor/'
    | '/workflow-editor/'
    | '/workflows/'
    | '/bi/'
    | '/help-center/'
    | '/no-organization/'
    | '/settings/'
    | '/auditor/clients/$id'
    | '/corporate-finance/projects/$id'
    | '/corporate-finance/taxonomies/$taxonomyId'
    | '/fas/projects/$id'
    | '/fas/taxonomies/$taxonomyId'
    | '/help-center/articles/new'
    | '/organization/$orgId/review'
    | '/superuser/usage/sessions'
    | '/superuser/user/$id'
    | '/template-editor/statement-trees/$taxonomyId'
    | '/template-editor/statement-trees/new'
    | '/auditor/validation/create'
    | '/help-center/admin/articles'
    | '/help-center/admin/faqs'
    | '/help-center/admin/release-notes'
    | '/help-center/admin/templates'
    | '/help-center/admin/topics'
    | '/help-center/release-notes/new'
    | '/superuser/usage/conversations'
    | '/corporate-finance/validation/'
    | '/document-analysis/create/'
    | '/help-center/articles/'
    | '/help-center/search/'
    | '/organization/$orgId/'
    | '/superuser/usage/'
    | '/workflows/run/'
    | '/auditor/clients/'
    | '/auditor/validation/'
    | '/corporate-finance/projects/'
    | '/fas/projects/'
    | '/help-center/faq/'
    | '/help-center/release-notes/'
    | '/auditor/clients/$id/agbw'
    | '/auditor/clients/$id/agbw-results'
    | '/corporate-finance/projects/$id/account-mapping'
    | '/help-center/articles/$id/edit'
    | '/organization/$orgId/department/$departmentId'
    | '/template-editor/classification-templates/$templateId/create-version'
    | '/fas/projects/$id/account-mapping'
    | '/help-center/release-notes/$id/edit'
    | '/organization/$orgId/review/$sessionId'
    | '/superuser/usage/sessions/$sessionId'
    | '/superuser/user/$id/permissions'
    | '/superuser/user/$id/roles'
    | '/template-editor/classification-templates/create/'
    | '/auditor/validation/$id/'
    | '/help-center/articles/$id/'
    | '/help-center/release-notes/$id/'
    | '/organization/$orgId/departments/'
    | '/organization/$orgId/invitations/'
    | '/organization/$orgId/training/'
    | '/organization/$orgId/users/'
    | '/auditor/clients/$id/metadata'
    | '/auditor/clients/$id/agbw-overview'
    | '/auditor/clients/$id/continuous-auditor-results'
    | '/auditor/clients/$id/document-analysis'
    | '/auditor/clients/$id/financial-explorer'
    | '/auditor/clients/$id/input-process'
    | '/auditor/clients/$id/tasks'
    | '/auditor/clients/$id/validations'
    | '/auditor/clients/$id/agbw-results/fraud-with-payments'
    | '/auditor/clients/$id/agbw-results/miscellaneous'
    | '/auditor/clients/$id/agbw-results/wwft-corruption'
    | '/auditor/clients/$id/analysis/$rid'
    | '/auditor/clients/$id/classifications/editor'
    | '/corporate-finance/projects/$id/financial-explorer'
    | '/corporate-finance/projects/$id/input-process'
    | '/corporate-finance/projects/$id/analysis/$rid'
    | '/fas/projects/$id/financial-explorer'
    | '/fas/projects/$id/input-process'
    | '/organization/$orgId/department/$departmentId/review'
    | '/auditor/clients/$id/affiliates'
    | '/auditor/clients/$id/batches'
    | '/auditor/clients/$id/camt'
    | '/auditor/clients/$id/trial-balance'
    | '/auditor/clients/$id/agbw-results/overview'
    | '/corporate-finance/projects/$id/document-analysis'
    | '/corporate-finance/projects/$id/workflows'
    | '/fas/projects/$id/workflows'
    | '/organization/$orgId/department/$departmentId/members'
    | '/organization/$orgId/user/$userId/'
    | '/auditor/clients/$id/'
    | '/corporate-finance/projects/$id/'
    | '/fas/projects/$id/'
    | '/organization/$orgId/department/$departmentId/'
    | '/auditor/clients/$id/input-process/classification'
    | '/auditor/clients/$id/input-process/reconciliation'
    | '/auditor/clients/$id/input-process/statement-extraction'
    | '/corporate-finance/projects/$id/input-process/classification'
    | '/auditor/clients/$id/input-process/documents'
    | '/auditor/clients/$id/input-process/trial-balance'
    | '/auditor/clients/$id/analysis/$rid/results'
    | '/corporate-finance/projects/$id/input-process/documents'
    | '/corporate-finance/projects/$id/input-process/reconciliation'
    | '/corporate-finance/projects/$id/input-process/statement-extraction'
    | '/corporate-finance/projects/$id/analysis/$rid/results'
    | '/organization/$orgId/department/$departmentId/review/$sessionId'
    | '/auditor/clients/$id/classifications/$cls/'
    | '/auditor/clients/$id/input-process/'
    | '/corporate-finance/projects/$id/input-process/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/corporate-finance'
    | '/fas'
    | '/data'
    | '/auth/change-password'
    | '/auth/forgot-password'
    | '/auth/sign-in'
    | '/auth/two-fa'
    | '/auth/two-fa-verify'
    | '/auth/verify'
    | '/auth/request-verify'
    | '/auth/sign-up'
    | '/auth/terms'
    | '/'
    | '/template-editor/statement-trees'
    | '/data/collections'
    | '/data/databases'
    | '/data/datasources'
    | '/document-analysis/bulk-results'
    | '/document-analysis/comparison'
    | '/document-analysis/results'
    | '/help-center/admin'
    | '/workflows/results'
    | '/workflows/schedule'
    | '/auth/workos/callback'
    | '/superuser/customers'
    | '/superuser/settings'
    | '/auditor'
    | '/document-analysis'
    | '/history'
    | '/not-authorized'
    | '/report-issue'
    | '/superuser'
    | '/template-editor'
    | '/workflow-editor'
    | '/workflows'
    | '/bi'
    | '/help-center'
    | '/no-organization'
    | '/settings'
    | '/auditor/clients/$id'
    | '/corporate-finance/projects/$id'
    | '/corporate-finance/taxonomies/$taxonomyId'
    | '/fas/projects/$id'
    | '/fas/taxonomies/$taxonomyId'
    | '/help-center/articles/new'
    | '/organization/$orgId/review'
    | '/superuser/usage/sessions'
    | '/superuser/user/$id'
    | '/template-editor/statement-trees/$taxonomyId'
    | '/template-editor/statement-trees/new'
    | '/auditor/validation/create'
    | '/help-center/admin/articles'
    | '/help-center/admin/faqs'
    | '/help-center/admin/release-notes'
    | '/help-center/admin/templates'
    | '/help-center/admin/topics'
    | '/help-center/release-notes/new'
    | '/superuser/usage/conversations'
    | '/corporate-finance/validation'
    | '/document-analysis/create'
    | '/help-center/articles'
    | '/help-center/search'
    | '/organization/$orgId'
    | '/superuser/usage'
    | '/workflows/run'
    | '/auditor/clients'
    | '/auditor/validation'
    | '/corporate-finance/projects'
    | '/fas/projects'
    | '/help-center/faq'
    | '/help-center/release-notes'
    | '/auditor/clients/$id/agbw'
    | '/auditor/clients/$id/agbw-results'
    | '/corporate-finance/projects/$id/account-mapping'
    | '/help-center/articles/$id/edit'
    | '/template-editor/classification-templates/$templateId/create-version'
    | '/fas/projects/$id/account-mapping'
    | '/help-center/release-notes/$id/edit'
    | '/organization/$orgId/review/$sessionId'
    | '/superuser/usage/sessions/$sessionId'
    | '/superuser/user/$id/permissions'
    | '/superuser/user/$id/roles'
    | '/template-editor/classification-templates/create'
    | '/auditor/validation/$id'
    | '/help-center/articles/$id'
    | '/help-center/release-notes/$id'
    | '/organization/$orgId/departments'
    | '/organization/$orgId/invitations'
    | '/organization/$orgId/training'
    | '/organization/$orgId/users'
    | '/auditor/clients/$id/metadata'
    | '/auditor/clients/$id/agbw-overview'
    | '/auditor/clients/$id/continuous-auditor-results'
    | '/auditor/clients/$id/document-analysis'
    | '/auditor/clients/$id/financial-explorer'
    | '/auditor/clients/$id/tasks'
    | '/auditor/clients/$id/validations'
    | '/auditor/clients/$id/agbw-results/fraud-with-payments'
    | '/auditor/clients/$id/agbw-results/miscellaneous'
    | '/auditor/clients/$id/agbw-results/wwft-corruption'
    | '/auditor/clients/$id/analysis/$rid'
    | '/auditor/clients/$id/classifications/editor'
    | '/corporate-finance/projects/$id/financial-explorer'
    | '/corporate-finance/projects/$id/analysis/$rid'
    | '/fas/projects/$id/financial-explorer'
    | '/fas/projects/$id/input-process'
    | '/organization/$orgId/department/$departmentId/review'
    | '/auditor/clients/$id/affiliates'
    | '/auditor/clients/$id/batches'
    | '/auditor/clients/$id/camt'
    | '/auditor/clients/$id/trial-balance'
    | '/auditor/clients/$id/agbw-results/overview'
    | '/corporate-finance/projects/$id/document-analysis'
    | '/corporate-finance/projects/$id/workflows'
    | '/fas/projects/$id/workflows'
    | '/organization/$orgId/department/$departmentId/members'
    | '/organization/$orgId/user/$userId'
    | '/organization/$orgId/department/$departmentId'
    | '/auditor/clients/$id/input-process/classification'
    | '/auditor/clients/$id/input-process/reconciliation'
    | '/auditor/clients/$id/input-process/statement-extraction'
    | '/corporate-finance/projects/$id/input-process/classification'
    | '/auditor/clients/$id/input-process/documents'
    | '/auditor/clients/$id/input-process/trial-balance'
    | '/auditor/clients/$id/analysis/$rid/results'
    | '/corporate-finance/projects/$id/input-process/documents'
    | '/corporate-finance/projects/$id/input-process/reconciliation'
    | '/corporate-finance/projects/$id/input-process/statement-extraction'
    | '/corporate-finance/projects/$id/analysis/$rid/results'
    | '/organization/$orgId/department/$departmentId/review/$sessionId'
    | '/auditor/clients/$id/classifications/$cls'
    | '/auditor/clients/$id/input-process'
    | '/corporate-finance/projects/$id/input-process'
  id:
    | '__root__'
    | '/_protected'
    | '/auth'
    | '/_protected/auditor'
    | '/_protected/corporate-finance'
    | '/_protected/fas'
    | '/_protected/superuser'
    | '/_protected/data'
    | '/_protected/workflows'
    | '/auth/change-password'
    | '/auth/forgot-password'
    | '/auth/sign-in'
    | '/auth/two-fa'
    | '/auth/two-fa-verify'
    | '/auth/verify'
    | '/auth/request-verify'
    | '/auth/sign-up'
    | '/auth/terms'
    | '/_protected/'
    | '/_protected/template-editor/statement-trees'
    | '/_protected/data/collections'
    | '/_protected/data/databases'
    | '/_protected/data/datasources'
    | '/_protected/document-analysis/bulk-results'
    | '/_protected/document-analysis/comparison'
    | '/_protected/document-analysis/results'
    | '/_protected/help-center/admin'
    | '/_protected/organization/$orgId'
    | '/_protected/workflows/results'
    | '/_protected/workflows/schedule'
    | '/auth/workos/callback'
    | '/_protected/superuser/customers'
    | '/_protected/superuser/settings'
    | '/_protected/superuser/usage'
    | '/_protected/auditor/'
    | '/_protected/document-analysis/'
    | '/_protected/history/'
    | '/_protected/not-authorized/'
    | '/_protected/report-issue/'
    | '/_protected/superuser/'
    | '/_protected/template-editor/'
    | '/_protected/workflow-editor/'
    | '/_protected/workflows/'
    | '/_protected/bi/'
    | '/_protected/help-center/'
    | '/_protected/no-organization/'
    | '/_protected/settings/'
    | '/_protected/auditor/clients/$id'
    | '/_protected/corporate-finance/projects/$id'
    | '/_protected/corporate-finance/taxonomies/$taxonomyId'
    | '/_protected/fas/projects/$id'
    | '/_protected/fas/taxonomies/$taxonomyId'
    | '/_protected/help-center/articles/new'
    | '/_protected/organization/$orgId/review'
    | '/_protected/superuser/usage/sessions'
    | '/_protected/superuser/user/$id'
    | '/_protected/template-editor/statement-trees/$taxonomyId'
    | '/_protected/template-editor/statement-trees/new'
    | '/_protected/auditor/validation/create'
    | '/_protected/help-center/admin/articles'
    | '/_protected/help-center/admin/faqs'
    | '/_protected/help-center/admin/release-notes'
    | '/_protected/help-center/admin/templates'
    | '/_protected/help-center/admin/topics'
    | '/_protected/help-center/release-notes/new'
    | '/_protected/superuser/usage/conversations'
    | '/_protected/corporate-finance/validation/'
    | '/_protected/document-analysis/create/'
    | '/_protected/help-center/articles/'
    | '/_protected/help-center/search/'
    | '/_protected/organization/$orgId/'
    | '/_protected/superuser/usage/'
    | '/_protected/workflows_/run/'
    | '/_protected/auditor/clients/'
    | '/_protected/auditor/validation/'
    | '/_protected/corporate-finance/projects/'
    | '/_protected/fas/projects/'
    | '/_protected/help-center/faq/'
    | '/_protected/help-center/release-notes/'
    | '/_protected/auditor/clients/$id/agbw'
    | '/_protected/auditor/clients/$id/agbw-results'
    | '/_protected/corporate-finance/projects/$id/account-mapping'
    | '/_protected/help-center/articles/$id/edit'
    | '/_protected/organization/$orgId_/department/$departmentId'
    | '/_protected/template-editor/classification-templates/$templateId/create-version'
    | '/_protected/auditor/clients/$id/_agbw'
    | '/_protected/auditor/clients/$id/_client-tabs'
    | '/_protected/corporate-finance/projects/$id/_project-tabs'
    | '/_protected/fas/projects/$id/_project-tabs'
    | '/_protected/fas/projects/$id/account-mapping'
    | '/_protected/help-center/release-notes/$id/edit'
    | '/_protected/organization/$orgId_/review/$sessionId'
    | '/_protected/superuser/usage_/sessions/$sessionId'
    | '/_protected/superuser/user/$id/permissions'
    | '/_protected/superuser/user/$id/roles'
    | '/_protected/template-editor/classification-templates/create/'
    | '/_protected/auditor/validation/$id/'
    | '/_protected/help-center/articles/$id/'
    | '/_protected/help-center/release-notes/$id/'
    | '/_protected/organization/$orgId/departments/'
    | '/_protected/organization/$orgId/invitations/'
    | '/_protected/organization/$orgId/training/'
    | '/_protected/organization/$orgId/users/'
    | '/_protected/auditor/clients/$id/_agbw/metadata'
    | '/_protected/auditor/clients/$id/_client-tabs/agbw-overview'
    | '/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results'
    | '/_protected/auditor/clients/$id/_client-tabs/document-analysis'
    | '/_protected/auditor/clients/$id/_client-tabs/financial-explorer'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process'
    | '/_protected/auditor/clients/$id/_client-tabs/tasks'
    | '/_protected/auditor/clients/$id/_client-tabs/validations'
    | '/_protected/auditor/clients/$id/agbw-results/fraud-with-payments'
    | '/_protected/auditor/clients/$id/agbw-results/miscellaneous'
    | '/_protected/auditor/clients/$id/agbw-results/wwft-corruption'
    | '/_protected/auditor/clients/$id/analysis/$rid'
    | '/_protected/auditor/clients/$id/classifications/editor'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/financial-explorer'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/input-process'
    | '/_protected/corporate-finance/projects/$id/analysis/$rid'
    | '/_protected/fas/projects/$id/_project-tabs/financial-explorer'
    | '/_protected/fas/projects/$id/_project-tabs/input-process'
    | '/_protected/organization/$orgId_/department/$departmentId/review'
    | '/_protected/auditor/clients/$id/_agbw/affiliates'
    | '/_protected/auditor/clients/$id/_agbw/batches'
    | '/_protected/auditor/clients/$id/_agbw/camt'
    | '/_protected/auditor/clients/$id/_agbw/trial-balance'
    | '/_protected/auditor/clients/$id/agbw-results/overview'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/document-analysis'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/workflows'
    | '/_protected/fas/projects/$id/_project-tabs/workflows'
    | '/_protected/organization/$orgId_/department/$departmentId/members'
    | '/_protected/organization/$orgId/user/$userId/'
    | '/_protected/auditor/clients/$id/_client-tabs/'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/'
    | '/_protected/fas/projects/$id/_project-tabs/'
    | '/_protected/organization/$orgId_/department/$departmentId/'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process/classification'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/classification'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process/documents'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process/trial-balance'
    | '/_protected/auditor/clients/$id/analysis/$rid/results'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/documents'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/reconciliation'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/statement-extraction'
    | '/_protected/corporate-finance/projects/$id/analysis/$rid/results'
    | '/_protected/organization/$orgId_/department/$departmentId_/review/$sessionId'
    | '/_protected/auditor/clients/$id/classifications/$cls/'
    | '/_protected/auditor/clients/$id/_client-tabs/input-process/'
    | '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/auditor': {
      id: '/_protected/auditor'
      path: '/auditor'
      fullPath: '/auditor'
      preLoaderRoute: typeof ProtectedAuditorRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/corporate-finance': {
      id: '/_protected/corporate-finance'
      path: '/corporate-finance'
      fullPath: '/corporate-finance'
      preLoaderRoute: typeof ProtectedCorporateFinanceRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/data': {
      id: '/_protected/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof ProtectedDataRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/fas': {
      id: '/_protected/fas'
      path: '/fas'
      fullPath: '/fas'
      preLoaderRoute: typeof ProtectedFasRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/superuser': {
      id: '/_protected/superuser'
      path: '/superuser'
      fullPath: '/superuser'
      preLoaderRoute: typeof ProtectedSuperuserRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/workflows': {
      id: '/_protected/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof ProtectedWorkflowsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/auth/change-password': {
      id: '/auth/change-password'
      path: '/change-password'
      fullPath: '/auth/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/request-verify': {
      id: '/auth/request-verify'
      path: '/request-verify'
      fullPath: '/auth/request-verify'
      preLoaderRoute: typeof AuthRequestVerifyLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/terms': {
      id: '/auth/terms'
      path: '/terms'
      fullPath: '/auth/terms'
      preLoaderRoute: typeof AuthTermsLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/two-fa': {
      id: '/auth/two-fa'
      path: '/two-fa'
      fullPath: '/auth/two-fa'
      preLoaderRoute: typeof AuthTwoFaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/two-fa-verify': {
      id: '/auth/two-fa-verify'
      path: '/two-fa-verify'
      fullPath: '/auth/two-fa-verify'
      preLoaderRoute: typeof AuthTwoFaVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/auditor/': {
      id: '/_protected/auditor/'
      path: '/'
      fullPath: '/auditor/'
      preLoaderRoute: typeof ProtectedAuditorIndexRouteImport
      parentRoute: typeof ProtectedAuditorRouteRoute
    }
    '/_protected/bi/': {
      id: '/_protected/bi/'
      path: '/bi'
      fullPath: '/bi/'
      preLoaderRoute: typeof ProtectedBiIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/data/collections': {
      id: '/_protected/data/collections'
      path: '/collections'
      fullPath: '/data/collections'
      preLoaderRoute: typeof ProtectedDataCollectionsRouteImport
      parentRoute: typeof ProtectedDataRoute
    }
    '/_protected/data/databases': {
      id: '/_protected/data/databases'
      path: '/databases'
      fullPath: '/data/databases'
      preLoaderRoute: typeof ProtectedDataDatabasesRouteImport
      parentRoute: typeof ProtectedDataRoute
    }
    '/_protected/data/datasources': {
      id: '/_protected/data/datasources'
      path: '/datasources'
      fullPath: '/data/datasources'
      preLoaderRoute: typeof ProtectedDataDatasourcesRouteImport
      parentRoute: typeof ProtectedDataRoute
    }
    '/_protected/document-analysis/': {
      id: '/_protected/document-analysis/'
      path: '/document-analysis'
      fullPath: '/document-analysis/'
      preLoaderRoute: typeof ProtectedDocumentAnalysisIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/document-analysis/bulk-results': {
      id: '/_protected/document-analysis/bulk-results'
      path: '/document-analysis/bulk-results'
      fullPath: '/document-analysis/bulk-results'
      preLoaderRoute: typeof ProtectedDocumentAnalysisBulkResultsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/document-analysis/comparison': {
      id: '/_protected/document-analysis/comparison'
      path: '/document-analysis/comparison'
      fullPath: '/document-analysis/comparison'
      preLoaderRoute: typeof ProtectedDocumentAnalysisComparisonRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/document-analysis/results': {
      id: '/_protected/document-analysis/results'
      path: '/document-analysis/results'
      fullPath: '/document-analysis/results'
      preLoaderRoute: typeof ProtectedDocumentAnalysisResultsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/': {
      id: '/_protected/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof ProtectedHelpCenterIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/admin': {
      id: '/_protected/help-center/admin'
      path: '/help-center/admin'
      fullPath: '/help-center/admin'
      preLoaderRoute: typeof ProtectedHelpCenterAdminRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/history/': {
      id: '/_protected/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof ProtectedHistoryIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/no-organization/': {
      id: '/_protected/no-organization/'
      path: '/no-organization'
      fullPath: '/no-organization/'
      preLoaderRoute: typeof ProtectedNoOrganizationIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/not-authorized/': {
      id: '/_protected/not-authorized/'
      path: '/not-authorized'
      fullPath: '/not-authorized/'
      preLoaderRoute: typeof ProtectedNotAuthorizedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/organization/$orgId': {
      id: '/_protected/organization/$orgId'
      path: '/organization/$orgId'
      fullPath: '/organization/$orgId'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/report-issue/': {
      id: '/_protected/report-issue/'
      path: '/report-issue'
      fullPath: '/report-issue/'
      preLoaderRoute: typeof ProtectedReportIssueIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settings/': {
      id: '/_protected/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof ProtectedSettingsIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/superuser/': {
      id: '/_protected/superuser/'
      path: '/'
      fullPath: '/superuser/'
      preLoaderRoute: typeof ProtectedSuperuserIndexRouteImport
      parentRoute: typeof ProtectedSuperuserRouteRoute
    }
    '/_protected/superuser/customers': {
      id: '/_protected/superuser/customers'
      path: '/customers'
      fullPath: '/superuser/customers'
      preLoaderRoute: typeof ProtectedSuperuserCustomersLazyRouteImport
      parentRoute: typeof ProtectedSuperuserRouteRoute
    }
    '/_protected/superuser/settings': {
      id: '/_protected/superuser/settings'
      path: '/settings'
      fullPath: '/superuser/settings'
      preLoaderRoute: typeof ProtectedSuperuserSettingsLazyRouteImport
      parentRoute: typeof ProtectedSuperuserRouteRoute
    }
    '/_protected/superuser/usage': {
      id: '/_protected/superuser/usage'
      path: '/usage'
      fullPath: '/superuser/usage'
      preLoaderRoute: typeof ProtectedSuperuserUsageLazyRouteImport
      parentRoute: typeof ProtectedSuperuserRouteRoute
    }
    '/_protected/template-editor/': {
      id: '/_protected/template-editor/'
      path: '/template-editor'
      fullPath: '/template-editor/'
      preLoaderRoute: typeof ProtectedTemplateEditorIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/template-editor/statement-trees': {
      id: '/_protected/template-editor/statement-trees'
      path: '/template-editor/statement-trees'
      fullPath: '/template-editor/statement-trees'
      preLoaderRoute: typeof ProtectedTemplateEditorStatementTreesRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/workflow-editor/': {
      id: '/_protected/workflow-editor/'
      path: '/workflow-editor'
      fullPath: '/workflow-editor/'
      preLoaderRoute: typeof ProtectedWorkflowEditorIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/workflows/': {
      id: '/_protected/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof ProtectedWorkflowsIndexRouteImport
      parentRoute: typeof ProtectedWorkflowsRoute
    }
    '/_protected/workflows/results': {
      id: '/_protected/workflows/results'
      path: '/results'
      fullPath: '/workflows/results'
      preLoaderRoute: typeof ProtectedWorkflowsResultsRouteImport
      parentRoute: typeof ProtectedWorkflowsRoute
    }
    '/_protected/workflows/schedule': {
      id: '/_protected/workflows/schedule'
      path: '/schedule'
      fullPath: '/workflows/schedule'
      preLoaderRoute: typeof ProtectedWorkflowsScheduleRouteImport
      parentRoute: typeof ProtectedWorkflowsRoute
    }
    '/auth/workos/callback': {
      id: '/auth/workos/callback'
      path: '/workos/callback'
      fullPath: '/auth/workos/callback'
      preLoaderRoute: typeof AuthWorkosCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/auditor/clients/': {
      id: '/_protected/auditor/clients/'
      path: '/clients'
      fullPath: '/auditor/clients/'
      preLoaderRoute: typeof ProtectedAuditorClientsIndexLazyRouteImport
      parentRoute: typeof ProtectedAuditorRouteRoute
    }
    '/_protected/auditor/clients/$id': {
      id: '/_protected/auditor/clients/$id'
      path: '/clients/$id'
      fullPath: '/auditor/clients/$id'
      preLoaderRoute: typeof ProtectedAuditorClientsIdRouteImport
      parentRoute: typeof ProtectedAuditorRouteRoute
    }
    '/_protected/auditor/validation/': {
      id: '/_protected/auditor/validation/'
      path: '/validation'
      fullPath: '/auditor/validation/'
      preLoaderRoute: typeof ProtectedAuditorValidationIndexLazyRouteImport
      parentRoute: typeof ProtectedAuditorRouteRoute
    }
    '/_protected/auditor/validation/create': {
      id: '/_protected/auditor/validation/create'
      path: '/validation/create'
      fullPath: '/auditor/validation/create'
      preLoaderRoute: typeof ProtectedAuditorValidationCreateLazyRouteImport
      parentRoute: typeof ProtectedAuditorRouteRoute
    }
    '/_protected/corporate-finance/projects/': {
      id: '/_protected/corporate-finance/projects/'
      path: '/projects'
      fullPath: '/corporate-finance/projects/'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIndexLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceRouteRoute
    }
    '/_protected/corporate-finance/projects/$id': {
      id: '/_protected/corporate-finance/projects/$id'
      path: '/projects/$id'
      fullPath: '/corporate-finance/projects/$id'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdRouteImport
      parentRoute: typeof ProtectedCorporateFinanceRouteRoute
    }
    '/_protected/corporate-finance/taxonomies/$taxonomyId': {
      id: '/_protected/corporate-finance/taxonomies/$taxonomyId'
      path: '/taxonomies/$taxonomyId'
      fullPath: '/corporate-finance/taxonomies/$taxonomyId'
      preLoaderRoute: typeof ProtectedCorporateFinanceTaxonomiesTaxonomyIdRouteImport
      parentRoute: typeof ProtectedCorporateFinanceRouteRoute
    }
    '/_protected/corporate-finance/validation/': {
      id: '/_protected/corporate-finance/validation/'
      path: '/validation'
      fullPath: '/corporate-finance/validation/'
      preLoaderRoute: typeof ProtectedCorporateFinanceValidationIndexRouteImport
      parentRoute: typeof ProtectedCorporateFinanceRouteRoute
    }
    '/_protected/document-analysis/create/': {
      id: '/_protected/document-analysis/create/'
      path: '/document-analysis/create'
      fullPath: '/document-analysis/create/'
      preLoaderRoute: typeof ProtectedDocumentAnalysisCreateIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/fas/projects/': {
      id: '/_protected/fas/projects/'
      path: '/projects'
      fullPath: '/fas/projects/'
      preLoaderRoute: typeof ProtectedFasProjectsIndexLazyRouteImport
      parentRoute: typeof ProtectedFasRouteRoute
    }
    '/_protected/fas/projects/$id': {
      id: '/_protected/fas/projects/$id'
      path: '/projects/$id'
      fullPath: '/fas/projects/$id'
      preLoaderRoute: typeof ProtectedFasProjectsIdRouteImport
      parentRoute: typeof ProtectedFasRouteRoute
    }
    '/_protected/fas/taxonomies/$taxonomyId': {
      id: '/_protected/fas/taxonomies/$taxonomyId'
      path: '/taxonomies/$taxonomyId'
      fullPath: '/fas/taxonomies/$taxonomyId'
      preLoaderRoute: typeof ProtectedFasTaxonomiesTaxonomyIdRouteImport
      parentRoute: typeof ProtectedFasRouteRoute
    }
    '/_protected/help-center/admin/articles': {
      id: '/_protected/help-center/admin/articles'
      path: '/articles'
      fullPath: '/help-center/admin/articles'
      preLoaderRoute: typeof ProtectedHelpCenterAdminArticlesLazyRouteImport
      parentRoute: typeof ProtectedHelpCenterAdminRoute
    }
    '/_protected/help-center/admin/faqs': {
      id: '/_protected/help-center/admin/faqs'
      path: '/faqs'
      fullPath: '/help-center/admin/faqs'
      preLoaderRoute: typeof ProtectedHelpCenterAdminFaqsLazyRouteImport
      parentRoute: typeof ProtectedHelpCenterAdminRoute
    }
    '/_protected/help-center/admin/release-notes': {
      id: '/_protected/help-center/admin/release-notes'
      path: '/release-notes'
      fullPath: '/help-center/admin/release-notes'
      preLoaderRoute: typeof ProtectedHelpCenterAdminReleaseNotesLazyRouteImport
      parentRoute: typeof ProtectedHelpCenterAdminRoute
    }
    '/_protected/help-center/admin/templates': {
      id: '/_protected/help-center/admin/templates'
      path: '/templates'
      fullPath: '/help-center/admin/templates'
      preLoaderRoute: typeof ProtectedHelpCenterAdminTemplatesLazyRouteImport
      parentRoute: typeof ProtectedHelpCenterAdminRoute
    }
    '/_protected/help-center/admin/topics': {
      id: '/_protected/help-center/admin/topics'
      path: '/topics'
      fullPath: '/help-center/admin/topics'
      preLoaderRoute: typeof ProtectedHelpCenterAdminTopicsLazyRouteImport
      parentRoute: typeof ProtectedHelpCenterAdminRoute
    }
    '/_protected/help-center/articles/': {
      id: '/_protected/help-center/articles/'
      path: '/help-center/articles'
      fullPath: '/help-center/articles/'
      preLoaderRoute: typeof ProtectedHelpCenterArticlesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/articles/new': {
      id: '/_protected/help-center/articles/new'
      path: '/help-center/articles/new'
      fullPath: '/help-center/articles/new'
      preLoaderRoute: typeof ProtectedHelpCenterArticlesNewRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/faq/': {
      id: '/_protected/help-center/faq/'
      path: '/help-center/faq'
      fullPath: '/help-center/faq/'
      preLoaderRoute: typeof ProtectedHelpCenterFaqIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/release-notes/': {
      id: '/_protected/help-center/release-notes/'
      path: '/help-center/release-notes'
      fullPath: '/help-center/release-notes/'
      preLoaderRoute: typeof ProtectedHelpCenterReleaseNotesIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/release-notes/new': {
      id: '/_protected/help-center/release-notes/new'
      path: '/help-center/release-notes/new'
      fullPath: '/help-center/release-notes/new'
      preLoaderRoute: typeof ProtectedHelpCenterReleaseNotesNewLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/search/': {
      id: '/_protected/help-center/search/'
      path: '/help-center/search'
      fullPath: '/help-center/search/'
      preLoaderRoute: typeof ProtectedHelpCenterSearchIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/organization/$orgId/': {
      id: '/_protected/organization/$orgId/'
      path: '/'
      fullPath: '/organization/$orgId/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdIndexRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/organization/$orgId/review': {
      id: '/_protected/organization/$orgId/review'
      path: '/review'
      fullPath: '/organization/$orgId/review'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdReviewRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/superuser/usage/': {
      id: '/_protected/superuser/usage/'
      path: '/'
      fullPath: '/superuser/usage/'
      preLoaderRoute: typeof ProtectedSuperuserUsageIndexRouteImport
      parentRoute: typeof ProtectedSuperuserUsageLazyRoute
    }
    '/_protected/superuser/usage/conversations': {
      id: '/_protected/superuser/usage/conversations'
      path: '/conversations'
      fullPath: '/superuser/usage/conversations'
      preLoaderRoute: typeof ProtectedSuperuserUsageConversationsLazyRouteImport
      parentRoute: typeof ProtectedSuperuserUsageLazyRoute
    }
    '/_protected/superuser/usage/sessions': {
      id: '/_protected/superuser/usage/sessions'
      path: '/sessions'
      fullPath: '/superuser/usage/sessions'
      preLoaderRoute: typeof ProtectedSuperuserUsageSessionsRouteImport
      parentRoute: typeof ProtectedSuperuserUsageLazyRoute
    }
    '/_protected/superuser/user/$id': {
      id: '/_protected/superuser/user/$id'
      path: '/user/$id'
      fullPath: '/superuser/user/$id'
      preLoaderRoute: typeof ProtectedSuperuserUserIdRouteImport
      parentRoute: typeof ProtectedSuperuserRouteRoute
    }
    '/_protected/template-editor/statement-trees/$taxonomyId': {
      id: '/_protected/template-editor/statement-trees/$taxonomyId'
      path: '/$taxonomyId'
      fullPath: '/template-editor/statement-trees/$taxonomyId'
      preLoaderRoute: typeof ProtectedTemplateEditorStatementTreesTaxonomyIdRouteImport
      parentRoute: typeof ProtectedTemplateEditorStatementTreesRouteRoute
    }
    '/_protected/template-editor/statement-trees/new': {
      id: '/_protected/template-editor/statement-trees/new'
      path: '/new'
      fullPath: '/template-editor/statement-trees/new'
      preLoaderRoute: typeof ProtectedTemplateEditorStatementTreesNewRouteImport
      parentRoute: typeof ProtectedTemplateEditorStatementTreesRouteRoute
    }
    '/_protected/workflows_/run/': {
      id: '/_protected/workflows_/run/'
      path: '/workflows/run'
      fullPath: '/workflows/run/'
      preLoaderRoute: typeof ProtectedWorkflowsRunIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/auditor/clients/$id/_agbw': {
      id: '/_protected/auditor/clients/$id/_agbw'
      path: ''
      fullPath: '/auditor/clients/$id'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs': {
      id: '/_protected/auditor/clients/$id/_client-tabs'
      path: ''
      fullPath: '/auditor/clients/$id'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/auditor/clients/$id/agbw': {
      id: '/_protected/auditor/clients/$id/agbw'
      path: '/agbw'
      fullPath: '/auditor/clients/$id/agbw'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/auditor/clients/$id/agbw-results': {
      id: '/_protected/auditor/clients/$id/agbw-results'
      path: '/agbw-results'
      fullPath: '/auditor/clients/$id/agbw-results'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwResultsRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/auditor/validation/$id/': {
      id: '/_protected/auditor/validation/$id/'
      path: '/validation/$id'
      fullPath: '/auditor/validation/$id/'
      preLoaderRoute: typeof ProtectedAuditorValidationIdIndexLazyRouteImport
      parentRoute: typeof ProtectedAuditorRouteRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs'
      path: ''
      fullPath: '/corporate-finance/projects/$id'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdRoute
    }
    '/_protected/corporate-finance/projects/$id/account-mapping': {
      id: '/_protected/corporate-finance/projects/$id/account-mapping'
      path: '/account-mapping'
      fullPath: '/corporate-finance/projects/$id/account-mapping'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdAccountMappingRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdRoute
    }
    '/_protected/fas/projects/$id/_project-tabs': {
      id: '/_protected/fas/projects/$id/_project-tabs'
      path: ''
      fullPath: '/fas/projects/$id'
      preLoaderRoute: typeof ProtectedFasProjectsIdProjectTabsLazyRouteImport
      parentRoute: typeof ProtectedFasProjectsIdRoute
    }
    '/_protected/fas/projects/$id/account-mapping': {
      id: '/_protected/fas/projects/$id/account-mapping'
      path: '/account-mapping'
      fullPath: '/fas/projects/$id/account-mapping'
      preLoaderRoute: typeof ProtectedFasProjectsIdAccountMappingLazyRouteImport
      parentRoute: typeof ProtectedFasProjectsIdRoute
    }
    '/_protected/help-center/articles/$id/': {
      id: '/_protected/help-center/articles/$id/'
      path: '/help-center/articles/$id'
      fullPath: '/help-center/articles/$id/'
      preLoaderRoute: typeof ProtectedHelpCenterArticlesIdIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/articles/$id/edit': {
      id: '/_protected/help-center/articles/$id/edit'
      path: '/help-center/articles/$id/edit'
      fullPath: '/help-center/articles/$id/edit'
      preLoaderRoute: typeof ProtectedHelpCenterArticlesIdEditRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/release-notes/$id/': {
      id: '/_protected/help-center/release-notes/$id/'
      path: '/help-center/release-notes/$id'
      fullPath: '/help-center/release-notes/$id/'
      preLoaderRoute: typeof ProtectedHelpCenterReleaseNotesIdIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help-center/release-notes/$id/edit': {
      id: '/_protected/help-center/release-notes/$id/edit'
      path: '/help-center/release-notes/$id/edit'
      fullPath: '/help-center/release-notes/$id/edit'
      preLoaderRoute: typeof ProtectedHelpCenterReleaseNotesIdEditLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/organization/$orgId/departments/': {
      id: '/_protected/organization/$orgId/departments/'
      path: '/departments'
      fullPath: '/organization/$orgId/departments/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdDepartmentsIndexLazyRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/organization/$orgId/invitations/': {
      id: '/_protected/organization/$orgId/invitations/'
      path: '/invitations'
      fullPath: '/organization/$orgId/invitations/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdInvitationsIndexLazyRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/organization/$orgId/training/': {
      id: '/_protected/organization/$orgId/training/'
      path: '/training'
      fullPath: '/organization/$orgId/training/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdTrainingIndexLazyRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/organization/$orgId/users/': {
      id: '/_protected/organization/$orgId/users/'
      path: '/users'
      fullPath: '/organization/$orgId/users/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdUsersIndexLazyRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/organization/$orgId_/department/$departmentId': {
      id: '/_protected/organization/$orgId_/department/$departmentId'
      path: '/organization/$orgId/department/$departmentId'
      fullPath: '/organization/$orgId/department/$departmentId'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/organization/$orgId_/review/$sessionId': {
      id: '/_protected/organization/$orgId_/review/$sessionId'
      path: '/organization/$orgId/review/$sessionId'
      fullPath: '/organization/$orgId/review/$sessionId'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdReviewSessionIdLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/superuser/usage_/sessions/$sessionId': {
      id: '/_protected/superuser/usage_/sessions/$sessionId'
      path: '/usage/sessions/$sessionId'
      fullPath: '/superuser/usage/sessions/$sessionId'
      preLoaderRoute: typeof ProtectedSuperuserUsageSessionsSessionIdLazyRouteImport
      parentRoute: typeof ProtectedSuperuserRouteRoute
    }
    '/_protected/superuser/user/$id/permissions': {
      id: '/_protected/superuser/user/$id/permissions'
      path: '/permissions'
      fullPath: '/superuser/user/$id/permissions'
      preLoaderRoute: typeof ProtectedSuperuserUserIdPermissionsLazyRouteImport
      parentRoute: typeof ProtectedSuperuserUserIdRoute
    }
    '/_protected/superuser/user/$id/roles': {
      id: '/_protected/superuser/user/$id/roles'
      path: '/roles'
      fullPath: '/superuser/user/$id/roles'
      preLoaderRoute: typeof ProtectedSuperuserUserIdRolesLazyRouteImport
      parentRoute: typeof ProtectedSuperuserUserIdRoute
    }
    '/_protected/template-editor/classification-templates/$templateId/create-version': {
      id: '/_protected/template-editor/classification-templates/$templateId/create-version'
      path: '/template-editor/classification-templates/$templateId/create-version'
      fullPath: '/template-editor/classification-templates/$templateId/create-version'
      preLoaderRoute: typeof ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/template-editor/classification-templates/create/': {
      id: '/_protected/template-editor/classification-templates/create/'
      path: '/template-editor/classification-templates/create'
      fullPath: '/template-editor/classification-templates/create/'
      preLoaderRoute: typeof ProtectedTemplateEditorClassificationTemplatesCreateIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/auditor/clients/$id/_agbw/affiliates': {
      id: '/_protected/auditor/clients/$id/_agbw/affiliates'
      path: '/affiliates'
      fullPath: '/auditor/clients/$id/affiliates'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwAffiliatesLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwLazyRoute
    }
    '/_protected/auditor/clients/$id/_agbw/batches': {
      id: '/_protected/auditor/clients/$id/_agbw/batches'
      path: '/batches'
      fullPath: '/auditor/clients/$id/batches'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwBatchesLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwLazyRoute
    }
    '/_protected/auditor/clients/$id/_agbw/camt': {
      id: '/_protected/auditor/clients/$id/_agbw/camt'
      path: '/camt'
      fullPath: '/auditor/clients/$id/camt'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwCamtLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwLazyRoute
    }
    '/_protected/auditor/clients/$id/_agbw/metadata': {
      id: '/_protected/auditor/clients/$id/_agbw/metadata'
      path: '/metadata'
      fullPath: '/auditor/clients/$id/metadata'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwMetadataRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwLazyRoute
    }
    '/_protected/auditor/clients/$id/_agbw/trial-balance': {
      id: '/_protected/auditor/clients/$id/_agbw/trial-balance'
      path: '/trial-balance'
      fullPath: '/auditor/clients/$id/trial-balance'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwTrialBalanceLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/': {
      id: '/_protected/auditor/clients/$id/_client-tabs/'
      path: '/'
      fullPath: '/auditor/clients/$id/'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsIndexLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/agbw-overview': {
      id: '/_protected/auditor/clients/$id/_client-tabs/agbw-overview'
      path: '/agbw-overview'
      fullPath: '/auditor/clients/$id/agbw-overview'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsAgbwOverviewRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results': {
      id: '/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results'
      path: '/continuous-auditor-results'
      fullPath: '/auditor/clients/$id/continuous-auditor-results'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/document-analysis': {
      id: '/_protected/auditor/clients/$id/_client-tabs/document-analysis'
      path: '/document-analysis'
      fullPath: '/auditor/clients/$id/document-analysis'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsDocumentAnalysisRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/financial-explorer': {
      id: '/_protected/auditor/clients/$id/_client-tabs/financial-explorer'
      path: '/financial-explorer'
      fullPath: '/auditor/clients/$id/financial-explorer'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsFinancialExplorerRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process'
      path: '/input-process'
      fullPath: '/auditor/clients/$id/input-process'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/tasks': {
      id: '/_protected/auditor/clients/$id/_client-tabs/tasks'
      path: '/tasks'
      fullPath: '/auditor/clients/$id/tasks'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsTasksRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/validations': {
      id: '/_protected/auditor/clients/$id/_client-tabs/validations'
      path: '/validations'
      fullPath: '/auditor/clients/$id/validations'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsValidationsRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRoute
    }
    '/_protected/auditor/clients/$id/agbw-results/fraud-with-payments': {
      id: '/_protected/auditor/clients/$id/agbw-results/fraud-with-payments'
      path: '/fraud-with-payments'
      fullPath: '/auditor/clients/$id/agbw-results/fraud-with-payments'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwResultsRoute
    }
    '/_protected/auditor/clients/$id/agbw-results/miscellaneous': {
      id: '/_protected/auditor/clients/$id/agbw-results/miscellaneous'
      path: '/miscellaneous'
      fullPath: '/auditor/clients/$id/agbw-results/miscellaneous'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwResultsMiscellaneousRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwResultsRoute
    }
    '/_protected/auditor/clients/$id/agbw-results/overview': {
      id: '/_protected/auditor/clients/$id/agbw-results/overview'
      path: '/overview'
      fullPath: '/auditor/clients/$id/agbw-results/overview'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwResultsOverviewLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwResultsRoute
    }
    '/_protected/auditor/clients/$id/agbw-results/wwft-corruption': {
      id: '/_protected/auditor/clients/$id/agbw-results/wwft-corruption'
      path: '/wwft-corruption'
      fullPath: '/auditor/clients/$id/agbw-results/wwft-corruption'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAgbwResultsRoute
    }
    '/_protected/auditor/clients/$id/analysis/$rid': {
      id: '/_protected/auditor/clients/$id/analysis/$rid'
      path: '/analysis/$rid'
      fullPath: '/auditor/clients/$id/analysis/$rid'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAnalysisRidRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/auditor/clients/$id/classifications/editor': {
      id: '/_protected/auditor/clients/$id/classifications/editor'
      path: '/classifications/editor'
      fullPath: '/auditor/clients/$id/classifications/editor'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClassificationsEditorRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/'
      path: '/'
      fullPath: '/corporate-finance/projects/$id/'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/document-analysis': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/document-analysis'
      path: '/document-analysis'
      fullPath: '/corporate-finance/projects/$id/document-analysis'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/financial-explorer': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/financial-explorer'
      path: '/financial-explorer'
      fullPath: '/corporate-finance/projects/$id/financial-explorer'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/input-process'
      path: '/input-process'
      fullPath: '/corporate-finance/projects/$id/input-process'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/workflows': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/workflows'
      path: '/workflows'
      fullPath: '/corporate-finance/projects/$id/workflows'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute
    }
    '/_protected/corporate-finance/projects/$id/analysis/$rid': {
      id: '/_protected/corporate-finance/projects/$id/analysis/$rid'
      path: '/analysis/$rid'
      fullPath: '/corporate-finance/projects/$id/analysis/$rid'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdAnalysisRidRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdRoute
    }
    '/_protected/fas/projects/$id/_project-tabs/': {
      id: '/_protected/fas/projects/$id/_project-tabs/'
      path: '/'
      fullPath: '/fas/projects/$id/'
      preLoaderRoute: typeof ProtectedFasProjectsIdProjectTabsIndexLazyRouteImport
      parentRoute: typeof ProtectedFasProjectsIdProjectTabsLazyRoute
    }
    '/_protected/fas/projects/$id/_project-tabs/financial-explorer': {
      id: '/_protected/fas/projects/$id/_project-tabs/financial-explorer'
      path: '/financial-explorer'
      fullPath: '/fas/projects/$id/financial-explorer'
      preLoaderRoute: typeof ProtectedFasProjectsIdProjectTabsFinancialExplorerRouteImport
      parentRoute: typeof ProtectedFasProjectsIdProjectTabsLazyRoute
    }
    '/_protected/fas/projects/$id/_project-tabs/input-process': {
      id: '/_protected/fas/projects/$id/_project-tabs/input-process'
      path: '/input-process'
      fullPath: '/fas/projects/$id/input-process'
      preLoaderRoute: typeof ProtectedFasProjectsIdProjectTabsInputProcessRouteImport
      parentRoute: typeof ProtectedFasProjectsIdProjectTabsLazyRoute
    }
    '/_protected/fas/projects/$id/_project-tabs/workflows': {
      id: '/_protected/fas/projects/$id/_project-tabs/workflows'
      path: '/workflows'
      fullPath: '/fas/projects/$id/workflows'
      preLoaderRoute: typeof ProtectedFasProjectsIdProjectTabsWorkflowsLazyRouteImport
      parentRoute: typeof ProtectedFasProjectsIdProjectTabsLazyRoute
    }
    '/_protected/organization/$orgId/user/$userId/': {
      id: '/_protected/organization/$orgId/user/$userId/'
      path: '/user/$userId'
      fullPath: '/organization/$orgId/user/$userId/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdUserUserIdIndexRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdRoute
    }
    '/_protected/organization/$orgId_/department/$departmentId/': {
      id: '/_protected/organization/$orgId_/department/$departmentId/'
      path: '/'
      fullPath: '/organization/$orgId/department/$departmentId/'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute
    }
    '/_protected/organization/$orgId_/department/$departmentId/members': {
      id: '/_protected/organization/$orgId_/department/$departmentId/members'
      path: '/members'
      fullPath: '/organization/$orgId/department/$departmentId/members'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute
    }
    '/_protected/organization/$orgId_/department/$departmentId/review': {
      id: '/_protected/organization/$orgId_/department/$departmentId/review'
      path: '/review'
      fullPath: '/organization/$orgId/department/$departmentId/review'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRouteImport
      parentRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process/': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process/'
      path: '/'
      fullPath: '/auditor/clients/$id/input-process/'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process/classification': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process/classification'
      path: '/classification'
      fullPath: '/auditor/clients/$id/input-process/classification'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessClassificationRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process/documents': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process/documents'
      path: '/documents'
      fullPath: '/auditor/clients/$id/input-process/documents'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process/reconciliation'
      path: '/reconciliation'
      fullPath: '/auditor/clients/$id/input-process/reconciliation'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process/statement-extraction'
      path: '/statement-extraction'
      fullPath: '/auditor/clients/$id/input-process/statement-extraction'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRoute
    }
    '/_protected/auditor/clients/$id/_client-tabs/input-process/trial-balance': {
      id: '/_protected/auditor/clients/$id/_client-tabs/input-process/trial-balance'
      path: '/trial-balance'
      fullPath: '/auditor/clients/$id/input-process/trial-balance'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRoute
    }
    '/_protected/auditor/clients/$id/analysis/$rid/results': {
      id: '/_protected/auditor/clients/$id/analysis/$rid/results'
      path: '/results'
      fullPath: '/auditor/clients/$id/analysis/$rid/results'
      preLoaderRoute: typeof ProtectedAuditorClientsIdAnalysisRidResultsLazyRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdAnalysisRidRoute
    }
    '/_protected/auditor/clients/$id/classifications/$cls/': {
      id: '/_protected/auditor/clients/$id/classifications/$cls/'
      path: '/classifications/$cls'
      fullPath: '/auditor/clients/$id/classifications/$cls/'
      preLoaderRoute: typeof ProtectedAuditorClientsIdClassificationsClsIndexRouteImport
      parentRoute: typeof ProtectedAuditorClientsIdRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/'
      path: '/'
      fullPath: '/corporate-finance/projects/$id/input-process/'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/classification': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/classification'
      path: '/classification'
      fullPath: '/corporate-finance/projects/$id/input-process/classification'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/documents': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/documents'
      path: '/documents'
      fullPath: '/corporate-finance/projects/$id/input-process/documents'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/reconciliation': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/reconciliation'
      path: '/reconciliation'
      fullPath: '/corporate-finance/projects/$id/input-process/reconciliation'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute
    }
    '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/statement-extraction': {
      id: '/_protected/corporate-finance/projects/$id/_project-tabs/input-process/statement-extraction'
      path: '/statement-extraction'
      fullPath: '/corporate-finance/projects/$id/input-process/statement-extraction'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute
    }
    '/_protected/corporate-finance/projects/$id/analysis/$rid/results': {
      id: '/_protected/corporate-finance/projects/$id/analysis/$rid/results'
      path: '/results'
      fullPath: '/corporate-finance/projects/$id/analysis/$rid/results'
      preLoaderRoute: typeof ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRouteImport
      parentRoute: typeof ProtectedCorporateFinanceProjectsIdAnalysisRidRoute
    }
    '/_protected/organization/$orgId_/department/$departmentId_/review/$sessionId': {
      id: '/_protected/organization/$orgId_/department/$departmentId_/review/$sessionId'
      path: '/organization/$orgId/department/$departmentId/review/$sessionId'
      fullPath: '/organization/$orgId/department/$departmentId/review/$sessionId'
      preLoaderRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedAuditorClientsIdAgbwResultsRouteChildren {
  ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute: typeof ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute
  ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute: typeof ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute
  ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute: typeof ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute
  ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute: typeof ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute
}

const ProtectedAuditorClientsIdAgbwResultsRouteChildren: ProtectedAuditorClientsIdAgbwResultsRouteChildren =
  {
    ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute:
      ProtectedAuditorClientsIdAgbwResultsFraudWithPaymentsRoute,
    ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute:
      ProtectedAuditorClientsIdAgbwResultsMiscellaneousRoute,
    ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute:
      ProtectedAuditorClientsIdAgbwResultsWwftCorruptionRoute,
    ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute:
      ProtectedAuditorClientsIdAgbwResultsOverviewLazyRoute,
  }

const ProtectedAuditorClientsIdAgbwResultsRouteWithChildren =
  ProtectedAuditorClientsIdAgbwResultsRoute._addFileChildren(
    ProtectedAuditorClientsIdAgbwResultsRouteChildren,
  )

interface ProtectedAuditorClientsIdAgbwLazyRouteChildren {
  ProtectedAuditorClientsIdAgbwMetadataRoute: typeof ProtectedAuditorClientsIdAgbwMetadataRoute
  ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute: typeof ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute
  ProtectedAuditorClientsIdAgbwBatchesLazyRoute: typeof ProtectedAuditorClientsIdAgbwBatchesLazyRoute
  ProtectedAuditorClientsIdAgbwCamtLazyRoute: typeof ProtectedAuditorClientsIdAgbwCamtLazyRoute
  ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute: typeof ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute
}

const ProtectedAuditorClientsIdAgbwLazyRouteChildren: ProtectedAuditorClientsIdAgbwLazyRouteChildren =
  {
    ProtectedAuditorClientsIdAgbwMetadataRoute:
      ProtectedAuditorClientsIdAgbwMetadataRoute,
    ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute:
      ProtectedAuditorClientsIdAgbwAffiliatesLazyRoute,
    ProtectedAuditorClientsIdAgbwBatchesLazyRoute:
      ProtectedAuditorClientsIdAgbwBatchesLazyRoute,
    ProtectedAuditorClientsIdAgbwCamtLazyRoute:
      ProtectedAuditorClientsIdAgbwCamtLazyRoute,
    ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute:
      ProtectedAuditorClientsIdAgbwTrialBalanceLazyRoute,
  }

const ProtectedAuditorClientsIdAgbwLazyRouteWithChildren =
  ProtectedAuditorClientsIdAgbwLazyRoute._addFileChildren(
    ProtectedAuditorClientsIdAgbwLazyRouteChildren,
  )

interface ProtectedAuditorClientsIdClientTabsInputProcessRouteChildren {
  ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute
  ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute
  ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute
  ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute
  ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute
  ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute
}

const ProtectedAuditorClientsIdClientTabsInputProcessRouteChildren: ProtectedAuditorClientsIdClientTabsInputProcessRouteChildren =
  {
    ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessClassificationRoute,
    ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessReconciliationRoute,
    ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessStatementExtractionRoute,
    ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessDocumentsLazyRoute,
    ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessTrialBalanceLazyRoute,
    ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessIndexLazyRoute,
  }

const ProtectedAuditorClientsIdClientTabsInputProcessRouteWithChildren =
  ProtectedAuditorClientsIdClientTabsInputProcessRoute._addFileChildren(
    ProtectedAuditorClientsIdClientTabsInputProcessRouteChildren,
  )

interface ProtectedAuditorClientsIdClientTabsLazyRouteChildren {
  ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute: typeof ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute
  ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute: typeof ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute
  ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute: typeof ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute
  ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute: typeof ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute
  ProtectedAuditorClientsIdClientTabsInputProcessRoute: typeof ProtectedAuditorClientsIdClientTabsInputProcessRouteWithChildren
  ProtectedAuditorClientsIdClientTabsTasksRoute: typeof ProtectedAuditorClientsIdClientTabsTasksRoute
  ProtectedAuditorClientsIdClientTabsValidationsRoute: typeof ProtectedAuditorClientsIdClientTabsValidationsRoute
  ProtectedAuditorClientsIdClientTabsIndexLazyRoute: typeof ProtectedAuditorClientsIdClientTabsIndexLazyRoute
}

const ProtectedAuditorClientsIdClientTabsLazyRouteChildren: ProtectedAuditorClientsIdClientTabsLazyRouteChildren =
  {
    ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute:
      ProtectedAuditorClientsIdClientTabsAgbwOverviewRoute,
    ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute:
      ProtectedAuditorClientsIdClientTabsContinuousAuditorResultsRoute,
    ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute:
      ProtectedAuditorClientsIdClientTabsDocumentAnalysisRoute,
    ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute:
      ProtectedAuditorClientsIdClientTabsFinancialExplorerRoute,
    ProtectedAuditorClientsIdClientTabsInputProcessRoute:
      ProtectedAuditorClientsIdClientTabsInputProcessRouteWithChildren,
    ProtectedAuditorClientsIdClientTabsTasksRoute:
      ProtectedAuditorClientsIdClientTabsTasksRoute,
    ProtectedAuditorClientsIdClientTabsValidationsRoute:
      ProtectedAuditorClientsIdClientTabsValidationsRoute,
    ProtectedAuditorClientsIdClientTabsIndexLazyRoute:
      ProtectedAuditorClientsIdClientTabsIndexLazyRoute,
  }

const ProtectedAuditorClientsIdClientTabsLazyRouteWithChildren =
  ProtectedAuditorClientsIdClientTabsLazyRoute._addFileChildren(
    ProtectedAuditorClientsIdClientTabsLazyRouteChildren,
  )

interface ProtectedAuditorClientsIdAnalysisRidRouteChildren {
  ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute: typeof ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute
}

const ProtectedAuditorClientsIdAnalysisRidRouteChildren: ProtectedAuditorClientsIdAnalysisRidRouteChildren =
  {
    ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute:
      ProtectedAuditorClientsIdAnalysisRidResultsLazyRoute,
  }

const ProtectedAuditorClientsIdAnalysisRidRouteWithChildren =
  ProtectedAuditorClientsIdAnalysisRidRoute._addFileChildren(
    ProtectedAuditorClientsIdAnalysisRidRouteChildren,
  )

interface ProtectedAuditorClientsIdRouteChildren {
  ProtectedAuditorClientsIdAgbwRoute: typeof ProtectedAuditorClientsIdAgbwRoute
  ProtectedAuditorClientsIdAgbwResultsRoute: typeof ProtectedAuditorClientsIdAgbwResultsRouteWithChildren
  ProtectedAuditorClientsIdAgbwLazyRoute: typeof ProtectedAuditorClientsIdAgbwLazyRouteWithChildren
  ProtectedAuditorClientsIdClientTabsLazyRoute: typeof ProtectedAuditorClientsIdClientTabsLazyRouteWithChildren
  ProtectedAuditorClientsIdAnalysisRidRoute: typeof ProtectedAuditorClientsIdAnalysisRidRouteWithChildren
  ProtectedAuditorClientsIdClassificationsEditorRoute: typeof ProtectedAuditorClientsIdClassificationsEditorRoute
  ProtectedAuditorClientsIdClassificationsClsIndexRoute: typeof ProtectedAuditorClientsIdClassificationsClsIndexRoute
}

const ProtectedAuditorClientsIdRouteChildren: ProtectedAuditorClientsIdRouteChildren =
  {
    ProtectedAuditorClientsIdAgbwRoute: ProtectedAuditorClientsIdAgbwRoute,
    ProtectedAuditorClientsIdAgbwResultsRoute:
      ProtectedAuditorClientsIdAgbwResultsRouteWithChildren,
    ProtectedAuditorClientsIdAgbwLazyRoute:
      ProtectedAuditorClientsIdAgbwLazyRouteWithChildren,
    ProtectedAuditorClientsIdClientTabsLazyRoute:
      ProtectedAuditorClientsIdClientTabsLazyRouteWithChildren,
    ProtectedAuditorClientsIdAnalysisRidRoute:
      ProtectedAuditorClientsIdAnalysisRidRouteWithChildren,
    ProtectedAuditorClientsIdClassificationsEditorRoute:
      ProtectedAuditorClientsIdClassificationsEditorRoute,
    ProtectedAuditorClientsIdClassificationsClsIndexRoute:
      ProtectedAuditorClientsIdClassificationsClsIndexRoute,
  }

const ProtectedAuditorClientsIdRouteWithChildren =
  ProtectedAuditorClientsIdRoute._addFileChildren(
    ProtectedAuditorClientsIdRouteChildren,
  )

interface ProtectedAuditorRouteRouteChildren {
  ProtectedAuditorIndexRoute: typeof ProtectedAuditorIndexRoute
  ProtectedAuditorClientsIdRoute: typeof ProtectedAuditorClientsIdRouteWithChildren
  ProtectedAuditorValidationCreateLazyRoute: typeof ProtectedAuditorValidationCreateLazyRoute
  ProtectedAuditorClientsIndexLazyRoute: typeof ProtectedAuditorClientsIndexLazyRoute
  ProtectedAuditorValidationIndexLazyRoute: typeof ProtectedAuditorValidationIndexLazyRoute
  ProtectedAuditorValidationIdIndexLazyRoute: typeof ProtectedAuditorValidationIdIndexLazyRoute
}

const ProtectedAuditorRouteRouteChildren: ProtectedAuditorRouteRouteChildren = {
  ProtectedAuditorIndexRoute: ProtectedAuditorIndexRoute,
  ProtectedAuditorClientsIdRoute: ProtectedAuditorClientsIdRouteWithChildren,
  ProtectedAuditorValidationCreateLazyRoute:
    ProtectedAuditorValidationCreateLazyRoute,
  ProtectedAuditorClientsIndexLazyRoute: ProtectedAuditorClientsIndexLazyRoute,
  ProtectedAuditorValidationIndexLazyRoute:
    ProtectedAuditorValidationIndexLazyRoute,
  ProtectedAuditorValidationIdIndexLazyRoute:
    ProtectedAuditorValidationIdIndexLazyRoute,
}

const ProtectedAuditorRouteRouteWithChildren =
  ProtectedAuditorRouteRoute._addFileChildren(
    ProtectedAuditorRouteRouteChildren,
  )

interface ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteChildren {
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute
}

const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteChildren: ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteChildren =
  {
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessClassificationRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessDocumentsLazyRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessReconciliationLazyRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessStatementExtractionLazyRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessIndexLazyRoute,
  }

const ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteWithChildren =
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute._addFileChildren(
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteChildren,
  )

interface ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteChildren {
  ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteWithChildren
  ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute
}

const ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteChildren: ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteChildren =
  {
    ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsFinancialExplorerRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsInputProcessRouteWithChildren,
    ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsDocumentAnalysisLazyRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsWorkflowsLazyRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsIndexLazyRoute,
  }

const ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteWithChildren =
  ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute._addFileChildren(
    ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteChildren,
  )

interface ProtectedCorporateFinanceProjectsIdAnalysisRidRouteChildren {
  ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute: typeof ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute
}

const ProtectedCorporateFinanceProjectsIdAnalysisRidRouteChildren: ProtectedCorporateFinanceProjectsIdAnalysisRidRouteChildren =
  {
    ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute:
      ProtectedCorporateFinanceProjectsIdAnalysisRidResultsLazyRoute,
  }

const ProtectedCorporateFinanceProjectsIdAnalysisRidRouteWithChildren =
  ProtectedCorporateFinanceProjectsIdAnalysisRidRoute._addFileChildren(
    ProtectedCorporateFinanceProjectsIdAnalysisRidRouteChildren,
  )

interface ProtectedCorporateFinanceProjectsIdRouteChildren {
  ProtectedCorporateFinanceProjectsIdAccountMappingRoute: typeof ProtectedCorporateFinanceProjectsIdAccountMappingRoute
  ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute: typeof ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteWithChildren
  ProtectedCorporateFinanceProjectsIdAnalysisRidRoute: typeof ProtectedCorporateFinanceProjectsIdAnalysisRidRouteWithChildren
}

const ProtectedCorporateFinanceProjectsIdRouteChildren: ProtectedCorporateFinanceProjectsIdRouteChildren =
  {
    ProtectedCorporateFinanceProjectsIdAccountMappingRoute:
      ProtectedCorporateFinanceProjectsIdAccountMappingRoute,
    ProtectedCorporateFinanceProjectsIdProjectTabsLazyRoute:
      ProtectedCorporateFinanceProjectsIdProjectTabsLazyRouteWithChildren,
    ProtectedCorporateFinanceProjectsIdAnalysisRidRoute:
      ProtectedCorporateFinanceProjectsIdAnalysisRidRouteWithChildren,
  }

const ProtectedCorporateFinanceProjectsIdRouteWithChildren =
  ProtectedCorporateFinanceProjectsIdRoute._addFileChildren(
    ProtectedCorporateFinanceProjectsIdRouteChildren,
  )

interface ProtectedCorporateFinanceRouteRouteChildren {
  ProtectedCorporateFinanceProjectsIdRoute: typeof ProtectedCorporateFinanceProjectsIdRouteWithChildren
  ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute: typeof ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute
  ProtectedCorporateFinanceValidationIndexRoute: typeof ProtectedCorporateFinanceValidationIndexRoute
  ProtectedCorporateFinanceProjectsIndexLazyRoute: typeof ProtectedCorporateFinanceProjectsIndexLazyRoute
}

const ProtectedCorporateFinanceRouteRouteChildren: ProtectedCorporateFinanceRouteRouteChildren =
  {
    ProtectedCorporateFinanceProjectsIdRoute:
      ProtectedCorporateFinanceProjectsIdRouteWithChildren,
    ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute:
      ProtectedCorporateFinanceTaxonomiesTaxonomyIdRoute,
    ProtectedCorporateFinanceValidationIndexRoute:
      ProtectedCorporateFinanceValidationIndexRoute,
    ProtectedCorporateFinanceProjectsIndexLazyRoute:
      ProtectedCorporateFinanceProjectsIndexLazyRoute,
  }

const ProtectedCorporateFinanceRouteRouteWithChildren =
  ProtectedCorporateFinanceRouteRoute._addFileChildren(
    ProtectedCorporateFinanceRouteRouteChildren,
  )

interface ProtectedFasProjectsIdProjectTabsLazyRouteChildren {
  ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute: typeof ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute
  ProtectedFasProjectsIdProjectTabsInputProcessRoute: typeof ProtectedFasProjectsIdProjectTabsInputProcessRoute
  ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute: typeof ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute
  ProtectedFasProjectsIdProjectTabsIndexLazyRoute: typeof ProtectedFasProjectsIdProjectTabsIndexLazyRoute
}

const ProtectedFasProjectsIdProjectTabsLazyRouteChildren: ProtectedFasProjectsIdProjectTabsLazyRouteChildren =
  {
    ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute:
      ProtectedFasProjectsIdProjectTabsFinancialExplorerRoute,
    ProtectedFasProjectsIdProjectTabsInputProcessRoute:
      ProtectedFasProjectsIdProjectTabsInputProcessRoute,
    ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute:
      ProtectedFasProjectsIdProjectTabsWorkflowsLazyRoute,
    ProtectedFasProjectsIdProjectTabsIndexLazyRoute:
      ProtectedFasProjectsIdProjectTabsIndexLazyRoute,
  }

const ProtectedFasProjectsIdProjectTabsLazyRouteWithChildren =
  ProtectedFasProjectsIdProjectTabsLazyRoute._addFileChildren(
    ProtectedFasProjectsIdProjectTabsLazyRouteChildren,
  )

interface ProtectedFasProjectsIdRouteChildren {
  ProtectedFasProjectsIdProjectTabsLazyRoute: typeof ProtectedFasProjectsIdProjectTabsLazyRouteWithChildren
  ProtectedFasProjectsIdAccountMappingLazyRoute: typeof ProtectedFasProjectsIdAccountMappingLazyRoute
}

const ProtectedFasProjectsIdRouteChildren: ProtectedFasProjectsIdRouteChildren =
  {
    ProtectedFasProjectsIdProjectTabsLazyRoute:
      ProtectedFasProjectsIdProjectTabsLazyRouteWithChildren,
    ProtectedFasProjectsIdAccountMappingLazyRoute:
      ProtectedFasProjectsIdAccountMappingLazyRoute,
  }

const ProtectedFasProjectsIdRouteWithChildren =
  ProtectedFasProjectsIdRoute._addFileChildren(
    ProtectedFasProjectsIdRouteChildren,
  )

interface ProtectedFasRouteRouteChildren {
  ProtectedFasProjectsIdRoute: typeof ProtectedFasProjectsIdRouteWithChildren
  ProtectedFasTaxonomiesTaxonomyIdRoute: typeof ProtectedFasTaxonomiesTaxonomyIdRoute
  ProtectedFasProjectsIndexLazyRoute: typeof ProtectedFasProjectsIndexLazyRoute
}

const ProtectedFasRouteRouteChildren: ProtectedFasRouteRouteChildren = {
  ProtectedFasProjectsIdRoute: ProtectedFasProjectsIdRouteWithChildren,
  ProtectedFasTaxonomiesTaxonomyIdRoute: ProtectedFasTaxonomiesTaxonomyIdRoute,
  ProtectedFasProjectsIndexLazyRoute: ProtectedFasProjectsIndexLazyRoute,
}

const ProtectedFasRouteRouteWithChildren =
  ProtectedFasRouteRoute._addFileChildren(ProtectedFasRouteRouteChildren)

interface ProtectedSuperuserUsageLazyRouteChildren {
  ProtectedSuperuserUsageSessionsRoute: typeof ProtectedSuperuserUsageSessionsRoute
  ProtectedSuperuserUsageConversationsLazyRoute: typeof ProtectedSuperuserUsageConversationsLazyRoute
  ProtectedSuperuserUsageIndexRoute: typeof ProtectedSuperuserUsageIndexRoute
}

const ProtectedSuperuserUsageLazyRouteChildren: ProtectedSuperuserUsageLazyRouteChildren =
  {
    ProtectedSuperuserUsageSessionsRoute: ProtectedSuperuserUsageSessionsRoute,
    ProtectedSuperuserUsageConversationsLazyRoute:
      ProtectedSuperuserUsageConversationsLazyRoute,
    ProtectedSuperuserUsageIndexRoute: ProtectedSuperuserUsageIndexRoute,
  }

const ProtectedSuperuserUsageLazyRouteWithChildren =
  ProtectedSuperuserUsageLazyRoute._addFileChildren(
    ProtectedSuperuserUsageLazyRouteChildren,
  )

interface ProtectedSuperuserUserIdRouteChildren {
  ProtectedSuperuserUserIdPermissionsLazyRoute: typeof ProtectedSuperuserUserIdPermissionsLazyRoute
  ProtectedSuperuserUserIdRolesLazyRoute: typeof ProtectedSuperuserUserIdRolesLazyRoute
}

const ProtectedSuperuserUserIdRouteChildren: ProtectedSuperuserUserIdRouteChildren =
  {
    ProtectedSuperuserUserIdPermissionsLazyRoute:
      ProtectedSuperuserUserIdPermissionsLazyRoute,
    ProtectedSuperuserUserIdRolesLazyRoute:
      ProtectedSuperuserUserIdRolesLazyRoute,
  }

const ProtectedSuperuserUserIdRouteWithChildren =
  ProtectedSuperuserUserIdRoute._addFileChildren(
    ProtectedSuperuserUserIdRouteChildren,
  )

interface ProtectedSuperuserRouteRouteChildren {
  ProtectedSuperuserCustomersLazyRoute: typeof ProtectedSuperuserCustomersLazyRoute
  ProtectedSuperuserSettingsLazyRoute: typeof ProtectedSuperuserSettingsLazyRoute
  ProtectedSuperuserUsageLazyRoute: typeof ProtectedSuperuserUsageLazyRouteWithChildren
  ProtectedSuperuserIndexRoute: typeof ProtectedSuperuserIndexRoute
  ProtectedSuperuserUserIdRoute: typeof ProtectedSuperuserUserIdRouteWithChildren
  ProtectedSuperuserUsageSessionsSessionIdLazyRoute: typeof ProtectedSuperuserUsageSessionsSessionIdLazyRoute
}

const ProtectedSuperuserRouteRouteChildren: ProtectedSuperuserRouteRouteChildren =
  {
    ProtectedSuperuserCustomersLazyRoute: ProtectedSuperuserCustomersLazyRoute,
    ProtectedSuperuserSettingsLazyRoute: ProtectedSuperuserSettingsLazyRoute,
    ProtectedSuperuserUsageLazyRoute:
      ProtectedSuperuserUsageLazyRouteWithChildren,
    ProtectedSuperuserIndexRoute: ProtectedSuperuserIndexRoute,
    ProtectedSuperuserUserIdRoute: ProtectedSuperuserUserIdRouteWithChildren,
    ProtectedSuperuserUsageSessionsSessionIdLazyRoute:
      ProtectedSuperuserUsageSessionsSessionIdLazyRoute,
  }

const ProtectedSuperuserRouteRouteWithChildren =
  ProtectedSuperuserRouteRoute._addFileChildren(
    ProtectedSuperuserRouteRouteChildren,
  )

interface ProtectedDataRouteChildren {
  ProtectedDataCollectionsRoute: typeof ProtectedDataCollectionsRoute
  ProtectedDataDatabasesRoute: typeof ProtectedDataDatabasesRoute
  ProtectedDataDatasourcesRoute: typeof ProtectedDataDatasourcesRoute
}

const ProtectedDataRouteChildren: ProtectedDataRouteChildren = {
  ProtectedDataCollectionsRoute: ProtectedDataCollectionsRoute,
  ProtectedDataDatabasesRoute: ProtectedDataDatabasesRoute,
  ProtectedDataDatasourcesRoute: ProtectedDataDatasourcesRoute,
}

const ProtectedDataRouteWithChildren = ProtectedDataRoute._addFileChildren(
  ProtectedDataRouteChildren,
)

interface ProtectedWorkflowsRouteChildren {
  ProtectedWorkflowsResultsRoute: typeof ProtectedWorkflowsResultsRoute
  ProtectedWorkflowsScheduleRoute: typeof ProtectedWorkflowsScheduleRoute
  ProtectedWorkflowsIndexRoute: typeof ProtectedWorkflowsIndexRoute
}

const ProtectedWorkflowsRouteChildren: ProtectedWorkflowsRouteChildren = {
  ProtectedWorkflowsResultsRoute: ProtectedWorkflowsResultsRoute,
  ProtectedWorkflowsScheduleRoute: ProtectedWorkflowsScheduleRoute,
  ProtectedWorkflowsIndexRoute: ProtectedWorkflowsIndexRoute,
}

const ProtectedWorkflowsRouteWithChildren =
  ProtectedWorkflowsRoute._addFileChildren(ProtectedWorkflowsRouteChildren)

interface ProtectedTemplateEditorStatementTreesRouteRouteChildren {
  ProtectedTemplateEditorStatementTreesTaxonomyIdRoute: typeof ProtectedTemplateEditorStatementTreesTaxonomyIdRoute
  ProtectedTemplateEditorStatementTreesNewRoute: typeof ProtectedTemplateEditorStatementTreesNewRoute
}

const ProtectedTemplateEditorStatementTreesRouteRouteChildren: ProtectedTemplateEditorStatementTreesRouteRouteChildren =
  {
    ProtectedTemplateEditorStatementTreesTaxonomyIdRoute:
      ProtectedTemplateEditorStatementTreesTaxonomyIdRoute,
    ProtectedTemplateEditorStatementTreesNewRoute:
      ProtectedTemplateEditorStatementTreesNewRoute,
  }

const ProtectedTemplateEditorStatementTreesRouteRouteWithChildren =
  ProtectedTemplateEditorStatementTreesRouteRoute._addFileChildren(
    ProtectedTemplateEditorStatementTreesRouteRouteChildren,
  )

interface ProtectedHelpCenterAdminRouteChildren {
  ProtectedHelpCenterAdminArticlesLazyRoute: typeof ProtectedHelpCenterAdminArticlesLazyRoute
  ProtectedHelpCenterAdminFaqsLazyRoute: typeof ProtectedHelpCenterAdminFaqsLazyRoute
  ProtectedHelpCenterAdminReleaseNotesLazyRoute: typeof ProtectedHelpCenterAdminReleaseNotesLazyRoute
  ProtectedHelpCenterAdminTemplatesLazyRoute: typeof ProtectedHelpCenterAdminTemplatesLazyRoute
  ProtectedHelpCenterAdminTopicsLazyRoute: typeof ProtectedHelpCenterAdminTopicsLazyRoute
}

const ProtectedHelpCenterAdminRouteChildren: ProtectedHelpCenterAdminRouteChildren =
  {
    ProtectedHelpCenterAdminArticlesLazyRoute:
      ProtectedHelpCenterAdminArticlesLazyRoute,
    ProtectedHelpCenterAdminFaqsLazyRoute:
      ProtectedHelpCenterAdminFaqsLazyRoute,
    ProtectedHelpCenterAdminReleaseNotesLazyRoute:
      ProtectedHelpCenterAdminReleaseNotesLazyRoute,
    ProtectedHelpCenterAdminTemplatesLazyRoute:
      ProtectedHelpCenterAdminTemplatesLazyRoute,
    ProtectedHelpCenterAdminTopicsLazyRoute:
      ProtectedHelpCenterAdminTopicsLazyRoute,
  }

const ProtectedHelpCenterAdminRouteWithChildren =
  ProtectedHelpCenterAdminRoute._addFileChildren(
    ProtectedHelpCenterAdminRouteChildren,
  )

interface ProtectedOrganizationOrgIdRouteChildren {
  ProtectedOrganizationOrgIdReviewRoute: typeof ProtectedOrganizationOrgIdReviewRoute
  ProtectedOrganizationOrgIdIndexRoute: typeof ProtectedOrganizationOrgIdIndexRoute
  ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute: typeof ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute
  ProtectedOrganizationOrgIdInvitationsIndexLazyRoute: typeof ProtectedOrganizationOrgIdInvitationsIndexLazyRoute
  ProtectedOrganizationOrgIdTrainingIndexLazyRoute: typeof ProtectedOrganizationOrgIdTrainingIndexLazyRoute
  ProtectedOrganizationOrgIdUsersIndexLazyRoute: typeof ProtectedOrganizationOrgIdUsersIndexLazyRoute
  ProtectedOrganizationOrgIdUserUserIdIndexRoute: typeof ProtectedOrganizationOrgIdUserUserIdIndexRoute
}

const ProtectedOrganizationOrgIdRouteChildren: ProtectedOrganizationOrgIdRouteChildren =
  {
    ProtectedOrganizationOrgIdReviewRoute:
      ProtectedOrganizationOrgIdReviewRoute,
    ProtectedOrganizationOrgIdIndexRoute: ProtectedOrganizationOrgIdIndexRoute,
    ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute:
      ProtectedOrganizationOrgIdDepartmentsIndexLazyRoute,
    ProtectedOrganizationOrgIdInvitationsIndexLazyRoute:
      ProtectedOrganizationOrgIdInvitationsIndexLazyRoute,
    ProtectedOrganizationOrgIdTrainingIndexLazyRoute:
      ProtectedOrganizationOrgIdTrainingIndexLazyRoute,
    ProtectedOrganizationOrgIdUsersIndexLazyRoute:
      ProtectedOrganizationOrgIdUsersIndexLazyRoute,
    ProtectedOrganizationOrgIdUserUserIdIndexRoute:
      ProtectedOrganizationOrgIdUserUserIdIndexRoute,
  }

const ProtectedOrganizationOrgIdRouteWithChildren =
  ProtectedOrganizationOrgIdRoute._addFileChildren(
    ProtectedOrganizationOrgIdRouteChildren,
  )

interface ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteChildren {
  ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute
  ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute
  ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute
}

const ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteChildren: ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteChildren =
  {
    ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute:
      ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewRoute,
    ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute:
      ProtectedOrganizationOrgIdDepartmentDepartmentIdMembersLazyRoute,
    ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute:
      ProtectedOrganizationOrgIdDepartmentDepartmentIdIndexLazyRoute,
  }

const ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteWithChildren =
  ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute._addFileChildren(
    ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedAuditorRouteRoute: typeof ProtectedAuditorRouteRouteWithChildren
  ProtectedCorporateFinanceRouteRoute: typeof ProtectedCorporateFinanceRouteRouteWithChildren
  ProtectedFasRouteRoute: typeof ProtectedFasRouteRouteWithChildren
  ProtectedSuperuserRouteRoute: typeof ProtectedSuperuserRouteRouteWithChildren
  ProtectedDataRoute: typeof ProtectedDataRouteWithChildren
  ProtectedWorkflowsRoute: typeof ProtectedWorkflowsRouteWithChildren
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedTemplateEditorStatementTreesRouteRoute: typeof ProtectedTemplateEditorStatementTreesRouteRouteWithChildren
  ProtectedDocumentAnalysisBulkResultsRoute: typeof ProtectedDocumentAnalysisBulkResultsRoute
  ProtectedDocumentAnalysisComparisonRoute: typeof ProtectedDocumentAnalysisComparisonRoute
  ProtectedDocumentAnalysisResultsRoute: typeof ProtectedDocumentAnalysisResultsRoute
  ProtectedHelpCenterAdminRoute: typeof ProtectedHelpCenterAdminRouteWithChildren
  ProtectedOrganizationOrgIdRoute: typeof ProtectedOrganizationOrgIdRouteWithChildren
  ProtectedDocumentAnalysisIndexRoute: typeof ProtectedDocumentAnalysisIndexRoute
  ProtectedHistoryIndexRoute: typeof ProtectedHistoryIndexRoute
  ProtectedNotAuthorizedIndexRoute: typeof ProtectedNotAuthorizedIndexRoute
  ProtectedReportIssueIndexRoute: typeof ProtectedReportIssueIndexRoute
  ProtectedTemplateEditorIndexRoute: typeof ProtectedTemplateEditorIndexRoute
  ProtectedWorkflowEditorIndexRoute: typeof ProtectedWorkflowEditorIndexRoute
  ProtectedBiIndexLazyRoute: typeof ProtectedBiIndexLazyRoute
  ProtectedHelpCenterIndexLazyRoute: typeof ProtectedHelpCenterIndexLazyRoute
  ProtectedNoOrganizationIndexLazyRoute: typeof ProtectedNoOrganizationIndexLazyRoute
  ProtectedSettingsIndexLazyRoute: typeof ProtectedSettingsIndexLazyRoute
  ProtectedHelpCenterArticlesNewRoute: typeof ProtectedHelpCenterArticlesNewRoute
  ProtectedHelpCenterReleaseNotesNewLazyRoute: typeof ProtectedHelpCenterReleaseNotesNewLazyRoute
  ProtectedDocumentAnalysisCreateIndexRoute: typeof ProtectedDocumentAnalysisCreateIndexRoute
  ProtectedHelpCenterArticlesIndexRoute: typeof ProtectedHelpCenterArticlesIndexRoute
  ProtectedHelpCenterSearchIndexRoute: typeof ProtectedHelpCenterSearchIndexRoute
  ProtectedWorkflowsRunIndexRoute: typeof ProtectedWorkflowsRunIndexRoute
  ProtectedHelpCenterFaqIndexLazyRoute: typeof ProtectedHelpCenterFaqIndexLazyRoute
  ProtectedHelpCenterReleaseNotesIndexLazyRoute: typeof ProtectedHelpCenterReleaseNotesIndexLazyRoute
  ProtectedHelpCenterArticlesIdEditRoute: typeof ProtectedHelpCenterArticlesIdEditRoute
  ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteWithChildren
  ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute: typeof ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute
  ProtectedHelpCenterReleaseNotesIdEditLazyRoute: typeof ProtectedHelpCenterReleaseNotesIdEditLazyRoute
  ProtectedOrganizationOrgIdReviewSessionIdLazyRoute: typeof ProtectedOrganizationOrgIdReviewSessionIdLazyRoute
  ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute: typeof ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute
  ProtectedHelpCenterArticlesIdIndexLazyRoute: typeof ProtectedHelpCenterArticlesIdIndexLazyRoute
  ProtectedHelpCenterReleaseNotesIdIndexLazyRoute: typeof ProtectedHelpCenterReleaseNotesIdIndexLazyRoute
  ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute: typeof ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAuditorRouteRoute: ProtectedAuditorRouteRouteWithChildren,
  ProtectedCorporateFinanceRouteRoute:
    ProtectedCorporateFinanceRouteRouteWithChildren,
  ProtectedFasRouteRoute: ProtectedFasRouteRouteWithChildren,
  ProtectedSuperuserRouteRoute: ProtectedSuperuserRouteRouteWithChildren,
  ProtectedDataRoute: ProtectedDataRouteWithChildren,
  ProtectedWorkflowsRoute: ProtectedWorkflowsRouteWithChildren,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedTemplateEditorStatementTreesRouteRoute:
    ProtectedTemplateEditorStatementTreesRouteRouteWithChildren,
  ProtectedDocumentAnalysisBulkResultsRoute:
    ProtectedDocumentAnalysisBulkResultsRoute,
  ProtectedDocumentAnalysisComparisonRoute:
    ProtectedDocumentAnalysisComparisonRoute,
  ProtectedDocumentAnalysisResultsRoute: ProtectedDocumentAnalysisResultsRoute,
  ProtectedHelpCenterAdminRoute: ProtectedHelpCenterAdminRouteWithChildren,
  ProtectedOrganizationOrgIdRoute: ProtectedOrganizationOrgIdRouteWithChildren,
  ProtectedDocumentAnalysisIndexRoute: ProtectedDocumentAnalysisIndexRoute,
  ProtectedHistoryIndexRoute: ProtectedHistoryIndexRoute,
  ProtectedNotAuthorizedIndexRoute: ProtectedNotAuthorizedIndexRoute,
  ProtectedReportIssueIndexRoute: ProtectedReportIssueIndexRoute,
  ProtectedTemplateEditorIndexRoute: ProtectedTemplateEditorIndexRoute,
  ProtectedWorkflowEditorIndexRoute: ProtectedWorkflowEditorIndexRoute,
  ProtectedBiIndexLazyRoute: ProtectedBiIndexLazyRoute,
  ProtectedHelpCenterIndexLazyRoute: ProtectedHelpCenterIndexLazyRoute,
  ProtectedNoOrganizationIndexLazyRoute: ProtectedNoOrganizationIndexLazyRoute,
  ProtectedSettingsIndexLazyRoute: ProtectedSettingsIndexLazyRoute,
  ProtectedHelpCenterArticlesNewRoute: ProtectedHelpCenterArticlesNewRoute,
  ProtectedHelpCenterReleaseNotesNewLazyRoute:
    ProtectedHelpCenterReleaseNotesNewLazyRoute,
  ProtectedDocumentAnalysisCreateIndexRoute:
    ProtectedDocumentAnalysisCreateIndexRoute,
  ProtectedHelpCenterArticlesIndexRoute: ProtectedHelpCenterArticlesIndexRoute,
  ProtectedHelpCenterSearchIndexRoute: ProtectedHelpCenterSearchIndexRoute,
  ProtectedWorkflowsRunIndexRoute: ProtectedWorkflowsRunIndexRoute,
  ProtectedHelpCenterFaqIndexLazyRoute: ProtectedHelpCenterFaqIndexLazyRoute,
  ProtectedHelpCenterReleaseNotesIndexLazyRoute:
    ProtectedHelpCenterReleaseNotesIndexLazyRoute,
  ProtectedHelpCenterArticlesIdEditRoute:
    ProtectedHelpCenterArticlesIdEditRoute,
  ProtectedOrganizationOrgIdDepartmentDepartmentIdRoute:
    ProtectedOrganizationOrgIdDepartmentDepartmentIdRouteWithChildren,
  ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute:
    ProtectedTemplateEditorClassificationTemplatesTemplateIdCreateVersionRoute,
  ProtectedHelpCenterReleaseNotesIdEditLazyRoute:
    ProtectedHelpCenterReleaseNotesIdEditLazyRoute,
  ProtectedOrganizationOrgIdReviewSessionIdLazyRoute:
    ProtectedOrganizationOrgIdReviewSessionIdLazyRoute,
  ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute:
    ProtectedTemplateEditorClassificationTemplatesCreateIndexRoute,
  ProtectedHelpCenterArticlesIdIndexLazyRoute:
    ProtectedHelpCenterArticlesIdIndexLazyRoute,
  ProtectedHelpCenterReleaseNotesIdIndexLazyRoute:
    ProtectedHelpCenterReleaseNotesIdIndexLazyRoute,
  ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute:
    ProtectedOrganizationOrgIdDepartmentDepartmentIdReviewSessionIdLazyRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface AuthRouteChildren {
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthTwoFaRoute: typeof AuthTwoFaRoute
  AuthTwoFaVerifyRoute: typeof AuthTwoFaVerifyRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthRequestVerifyLazyRoute: typeof AuthRequestVerifyLazyRoute
  AuthSignUpLazyRoute: typeof AuthSignUpLazyRoute
  AuthTermsLazyRoute: typeof AuthTermsLazyRoute
  AuthWorkosCallbackRoute: typeof AuthWorkosCallbackRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthTwoFaRoute: AuthTwoFaRoute,
  AuthTwoFaVerifyRoute: AuthTwoFaVerifyRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthRequestVerifyLazyRoute: AuthRequestVerifyLazyRoute,
  AuthSignUpLazyRoute: AuthSignUpLazyRoute,
  AuthTermsLazyRoute: AuthTermsLazyRoute,
  AuthWorkosCallbackRoute: AuthWorkosCallbackRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
